
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Swiper from 'swiper';
require('./console');
require('./bootstrap');
require('jquery-toast-plugin');
require('./google_map');
require('selectize');
require('croppie');
require('jquery-bar-rating');
require('./search');
var showstar = require('./stars');
var breedList = require('./breed.json');
window.Vue = require('vue');
const toastService = require('./toast');
const base_url = window.location.origin;
const user = window.USER;
const stripeKey = window.STRIPE_KEY;
let IS_PREMEUM_ACCOUNT = user.premium;
const maxSize = 1024 * 1024 * 5;
const config_croppie_picture = {
    type: 'canvas',
    size: {
        width: 800,
        height: undefined
    },
    format:'jpeg',
    quality: 0.99
};
let activeRotateButton = false;
const regexDay = /^1[0-9]$|^0[1-9]$|^2[0-9]$|^3[0-1]$/;
const regexMonth = /^1[0-2]$|^0[1-9]$/;
// const regexYear = /^(1[0-9][0-9]\d|20[0-4]\d|2099)$/;

const checkage = function(year){
    var year_now = new Date().getFullYear();
    if (year_now - year >= 18){
        return true;
    }
    else {
        return false;
    }
}


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('example-component', require('./components/ExampleComponent.vue'));

// const app = new Vue({
//     el: '#app'
// });

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// $("input[type='file']").on("change", function () {
//     let maxSizeKB = 1024;
//     let maxSize = maxSizeKB * 1024;
//     if (this.files[0].size > maxSize) {
//         $(this).val("");
//         alert("Your photo is too large, must be less than 1024 kb");
//         return false;
//     }
// });

setTimeout(premiumInit, 100);
function premiumInit() {
    if (window.Stripe) {
        require('./premium');
    } else {
        setTimeout(premiumInit, 100);
    }
}

if ($('meta[name="register"]').length > 0){
    if ($('meta[name="register"]').attr('role') == 'owner') {
        $('#owner-info').modal({
            keyboard: false,
            backdrop: 'static',
            show: true,
        });
    } else if ($('meta[name="register"]').attr('role') == 'borrower') {
        $('#borrower-info').modal({
            keyboard: false,
            backdrop: 'static',
            show: true,
        });
    }
}

if ($('meta[name="socialite"]').length > 0) {
    if(isHomePage) {
        $('#startProfileModal').modal({
            keyboard: false,
            backdrop: 'static',
            show: true,
        });
    }
}

$('#find-location').on('click',function (e){
    e.preventDefault();
    searchGoogleMap();
});

var login_loading = false;
$('#submit-login').click(function(e) {
    e.preventDefault();
    if (login_loading) return;
    login_loading = true;
    var form = $(this).closest('form');
    var dataForm = {
        'email' : $('#email').val(),
        'password' : $('#password').val()
    };
    form.removeClass('was-validated');
    $('#email').get(0).setCustomValidity('');
    $('#password').get(0).setCustomValidity('');
    form.find('.invalid-feedback').remove();
    $('#email').closest('.form-group').find('.small-description').show();
    $('#password').closest('.form-group').find('.small-description').show();
    $.ajax({
        type:'POST',
        url:'/signin',
        data: dataForm,
        success:function(data){
            $('#signinModal').modal('hide');
            window.location = data.path;
            login_loading = false;
        },
        error:function (data) {
            form.addClass('was-validated');
            if(data.responseJSON.active == false){
                $('#error-active-email').show();
            }
            else {
                $('#error-active-email').hide();
            }
            $.each(data.responseJSON.message, function (k,v) {
                if (k == 'email') {
                    $('#email').closest('.form-group').find('.small-description').hide();
                    $( "<div class='invalid-feedback'>" + v + "</div>" ).insertAfter($('#email'));
                    $('#email').get(0).setCustomValidity('invalid');
                } else if (k == 'password'){
                    $('#password').closest('.form-group').find('.small-description').hide();
                    $( "<div class='invalid-feedback'>" + v + "</div>" ).insertAfter($('#password'));
                    $('#password').get(0).setCustomValidity('invalid');
                } else if (k == 'errorlogin') {
                    $('#email').get(0).setCustomValidity('invalid');
                    $('#password').get(0).setCustomValidity('invalid');
                    form.find('.respon-submit').append("<div class='invalid-feedback'>" + v + "</div>" );
                }
            });
            login_loading = false;
        }
    });
});

$('#show-email-again-modal').on('click', function (e) {
    e.preventDefault();
    var openSignin = true;
    $('#signinModal').modal('hide').on('hidden.bs.modal', function (e) {
            if (openSignin){
                $('#resend-activation-email-modal').modal('show');
                openSignin = false;
            }
    });
});

var signup_loading = false;
$('#submit-signup').click(function(e) {
    e.preventDefault();
    if (signup_loading) return;
    signup_loading = true;
    var form = $(this).closest('form');
    var email = form.find('#email-signup').val();
    var password = form.find('#password-signup').val();
    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#email-signup').get(0).setCustomValidity('');
    $('#password-signup').get(0).setCustomValidity('');
    if(!email || !password) {
        //form.addClass('was-validated');
        if (!email){
            form.find('.email-signup').find('.invalid-feedback').html("Email is required");
        }
        if (!password){
            form.find('.password-signup').find('.invalid-feedback').html("Password is required");
        }
    }
    $.ajax({
        type: 'POST',
        url: '/register/checkRegister',
        data: {
            'email' : email,
            'password': password
        },
        success: function (data) {
            form.removeClass('was-validated');
                $('#signupModal').one('hidden.bs.modal', () => {
                $('#startProfileModal').modal('show');
            }).modal('hide');
            signup_loading = false;
        },
        error: function (error) {
            form.addClass('was-validated');
            if (error.responseJSON.exist == true) {
                $('#error-account-exist').show();
            } else {
                $('#error-account-exist').hide();
                $.each(error.responseJSON.message, function (key, value) {
                    if (key == 'email') {
                        $("<div class='invalid-feedback'>" + value + "</div>").insertAfter($('#email-signup'));
                        $('#email-signup').get(0).setCustomValidity('invalid');
                    } else if (key == 'password') {
                        $("<div class='invalid-feedback'>" + value + "</div>").insertAfter($('#password-signup'));
                        $('#password-signup').get(0).setCustomValidity('invalid');
                    }

                });
            }
            signup_loading = false;
        }
    })
});

var start_profile_loading = false ;
$('#submit-start-profile').click(function (e) {
    $(this).find('#loading-submit-register > i').removeClass('not-processing');
    e.preventDefault();
    if (start_profile_loading) return;
    start_profile_loading = true;
    var formSignup = $("form#signup");
    var form = $(this).closest('form');
    searchGoogleMap().done(function () {
        var dataForm = {};
        if (form.hasClass('facebook')) {
            dataForm = {
                'role': form.find('input[name=role-user]:checked').val(),
                'first_name' : form.find('#first-name').val(),
                'last_name' : form.find('#last-name').val(),
                'location' : form.find('#location-id').val(),
                'location_lat' : form.find('#location-lat').val(),
                'location_lng' : form.find('#location-lng').val(),
                'location_address' : form.find('#location-address').val(),
                'location_address_detail' : form.find('#location-address-detail').val(),
                'email' : form.find('#email-provider').val(),
                'phone_number' : form.find('#phone-number').val(),
            };
            $('#email-signup').get(0).setCustomValidity('');
        } else if (form.hasClass('google')){
            dataForm = {
                'role': form.find('input[name=role-user]:checked').val(),
                'first_name' : form.find('#first-name').val(),
                'last_name' : form.find('#last-name').val(),
                'location' : form.find('#location-id').val(),
                'location_lat' : form.find('#location-lat').val(),
                'location_lng' : form.find('#location-lng').val(),
                'location_address' : form.find('#location-address').val(),
                'location_address_detail' : form.find('#location-address-detail').val(),
                'email' : form.find('#email-provider').val(),
                'phone_number' : form.find('#phone-number').val(),
            };
        } else {
            dataForm = {
                'role': form.find('input[name=role-user]:checked').val(),
                'first_name' : form.find('#first-name').val(),
                'last_name' : form.find('#last-name').val(),
                'location' : form.find('#location-id').val(),
                'location_lat' : form.find('#location-lat').val(),
                'location_lng' : form.find('#location-lng').val(),
                'location_address' : form.find('#location-address').val(),
                'location_address_detail' : form.find('#location-address-detail').val(),
                'phone_number' : form.find('#phone-number').val(),
                'email' : formSignup.find('#email-signup').val(),
                'password' : formSignup.find('#password-signup').val(),
            };
            $('#password-signup').get(0).setCustomValidity('');
            $('#email-signup').get(0).setCustomValidity('');
        }

        form.removeClass('was-validated');
        form.find('.invalid-feedback').remove();
        $('#location').get(0).setCustomValidity('');
        $('#first-name').get(0).setCustomValidity('');
        $('#last-name').get(0).setCustomValidity('');

        if ($('#start-profile-subscribe').is(':checked') && $('#start-profile-term').is(':checked')){
            dataForm.subscriber =1;
            subscribe(form,dataForm);
            registation(form,dataForm);

        }
        else if ($('#start-profile-term').is(':checked')){
            dataForm.subscriber =0;
            registation(form,dataForm);
        }
        else {
            $('#startProfileModal').find('#loading-submit-register > i').addClass('not-processing');
            start_profile_loading = false;
            form.find('.message-error').empty();
            form.find('.registation-term').find('.message-error').append('Du måste godkänna våra användarvillkor och integritetspolicy');
        }

    });
    });
function subscribe(form,dataForm) {
    form.find('.registation-term').find('.message-error').empty();
    $.ajax({
        type:'POST',
        url:'/mailchimp/subscribe',
        data: dataForm,
        success:function(data){
            var message = data['message'];
            if (data['error']) {
                toastService.error('Error', message);
            } else {
                toastService.success('Success', message);
                $('#email-subcribe').val('');
            }
        }
    });
}
function registation(form,dataForm) {
    form.find('.registation-term').find('.message-error').empty();
    $.ajax({
        type:'POST',
        url:'/register',
        data: dataForm,
        success:function(data){
            $('.formSignup').hide();
            $('.doneRegister').addClass('active');
            start_profile_loading = false;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'finish-creating-new-account'
            });
        },
        error: function(data){
            $('#startProfileModal').find('#loading-submit-register > i').addClass('not-processing');
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if (key == 'email'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#email-signup'));
                    $('#email-signup').get(0).setCustomValidity('invalid');
                } else if(key == 'location'){
                    $( "<div class='invalid-feedback'>Vänligen ange adress inom Sverige</div>" ).insertAfter($('#location'));
                    $('#location').get(0).setCustomValidity('invalid');
                } else if (key == 'phone_number'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#phone-number'));
                    $('#phone-number').get(0).setCustomValidity('invalid');
                } else if (key == 'first_name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#first-name'));
                    $('#first-name').get(0).setCustomValidity('invalid');
                } else if (key == 'last_name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#last-name'));
                    $('#last-name').get(0).setCustomValidity('invalid');
                }
            });
            start_profile_loading = false;

        }
    });
}
    $('.news-letter-owner').on('click',function () {
        if ($('.news-letter-owner').val()==1){
                $.ajax({
                    type:"POST",
                    url: "/mailchimp/unsubscribe"
                });
            $('.news-letter-owner').val(0);
            }
            else if ($('.news-letter-owner').val()==0){
                $.ajax({
                    type:"POST",
                    url: "/mailchimp/subscribe",
                });
            $('.news-letter-owner').val(1);
            }
    })

    $('.news-message-owner').on('click',function () {
        if ($('.news-message-owner').val()==1){
            $.ajax({
                type:"POST",
                url: "/subscriberMessage",
                data: {'subscriber':0}
            });
            $('.news-message-owner').val(0);
        }
        else if ($('.news-message-owner').val()==0){
            $.ajax({
                type:"POST",
                url: "/subscriberMessage",
                data: {'subscriber':1}
            });
            $('.news-message-owner').val(1);
        }
    })

    $('.news-comment-owner').on('click',function () {
        if ($('.news-comment-owner').val()==1){
            $.ajax({
                type:"POST",
                url: "/comment/subscriberComment",
                data: {subscriber: 0}
            });
            $('.news-comment-owner').val(0);
        }
        else if ($('.news-comment-owner').val()==0){
            $.ajax({
                type:"POST",
                url: "/comment/subscriberComment",
                data: {subscriber: 1}
            });
            $('.news-comment-owner').val(1);

        }
    })


$('body').off('click').on('click','.edit-comment-more', function () {
    $('#edit-comment-modal').modal('show');
    var content = '';
    var id_comment = '';
    var show_comment;
    var new_content;
    var select;
    var $parent = $(this).parent();
    if ($parent.hasClass('comment-user-info')) {
        select = 'parent';
        show_comment = $(this).parent().parent().find('.comment-content-parent');
        new_content = $(this).parent().find('.content-comment-more');
        var stars = $parent.find('.stars-comment-more').val();
        content = $parent.find('.content-comment-more').val();
        id_comment = $parent.find('.id-comment-more').val();
        var show_star = $(this).parent().parent().find('.rated-bar-profile');
        $('#edit-comment-modal').find('#edit-stars-comment').show();
        $('#edit-comment-modal').find('#content-direct-comment').val(content);
        $(function () {
            $('.select-stars').each(function (index, el) {
                const $El = $(el);
                $El.barrating({
                    theme: 'fontawesome-stars',
                    readonly: false,
                    initialRating: stars
                });
                $El.barrating('set', stars);
            });
        });
    } else if ($parent.hasClass('subcomment-user-info')) {
        select = 'child';
        show_comment = $(this).parent().parent().find('.comment-content');
        $('body').find('#edit-comment-modal').find('#edit-stars-comment').hide();
        content = $parent.find('.content-subcomment-more').val();
        new_content = $parent.find('.content-subcomment-more');
        id_comment = $parent.find('.id-subcomment-more').val();
        $('#edit-comment-modal').find('#content-direct-comment').val(content);
    }

    $('#submit-send-comment').off('click').on('click', function () {
        if (select == 'parent'){
            var rating_star = $(".select-stars option:selected").text();
        }
        else {
            var rating_star = null;
        }
        var _token = $("input[name='_token']").val();
        var new_comment = $('#content-direct-comment').val();
            if (show_star){
                showstar.editStars(show_star,rating_star);
            }
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $.ajax({
                type: "POST",
                dataType: "JSON",
                url: "/comment/editComment",
                data: {_token, 'message': new_comment, 'id': id_comment, 'stars': rating_star},
                success: function (data) {
                    show_comment.html(new_comment);
                    new_content.val(new_comment);
                    $parent.find('.stars-comment-more').val(rating_star);
                    $('#edit-comment-modal').modal('hide');
                    toastService.success('success', 'success');
                },
                error: function (data) {
                    toastService.error('error', data.responseJSON.message.message);
                }
            })
    })
});



$('.news-letter-borrower').on('click',function () {
    if ($('.news-letter-borrower').val()==1){
        $.ajax({
            type:"POST",
            url: "/mailchimp/unsubscribe"
        })
        $('.news-letter-borrower').val(0);
    }
    else if ($('.news-letter-borrower').val()==0){
        $.ajax({
            type:"POST",
            url: "/mailchimp/subscribe",
        })
        $('.news-letter-borrower').val(1);
    }
})


$('.news-message-borrower').on('click',function () {
    if ($('.news-message-borrower').val()==1){
        $.ajax({
            type:"POST",
            url: "/subscriberMessage",
            data: {'subscriber':0}
        })
        $('.news-message-borrower').val(0);
    }
    else if ($('.news-message-borrower').val()==0){
        $.ajax({
            type:"POST",
            url: "/subscriberMessage",
            data: {'subscriber':1}
        })
        $('.news-message-borrower').val(1);
    }
})
$('.news-comment-borrower').on('click',function () {
    if ($('.news-comment-borrower').val()==1){
        $.ajax({
            type:"POST",
            url: "/comment/subscriberComment",
            data: {subscriber: 0}
        })
        $('.news-comment-borrower').val(0);
    }
    else if ($('.news-comment-borrower').val()==0){
        $.ajax({
            type:"POST",
            url: "/comment/subscriberComment",
            data: {subscriber: 1}
        })
        $('.news-comment-borrower').val(1);

    }
})




function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$('#submit-subcribe').click(function(e) {
    e.preventDefault();

    var updateNews = $('#updateNews').is(':checked');
    var agreeTerm = $('#agreeTerm').is(':checked');
    var email = $('#email-subcribe').val().toLowerCase();


    if(updateNews && agreeTerm) {
        if (validateEmail(email)) {
            var dataForm = {
                'email' : email,

            };

            $.ajax({
                type:'POST',
                url:'/mailchimp/subscribe',
                data: dataForm,
                success:function(data){
                    var message = data['message'];
                    if (data['error']) {
                        toastService.error('Error', message);
                    } else {
                        toastService.success('Success', message);
                        $('#email-subcribe').val('');
                    }
                }
            });
        } else {
            var message = 'E-post måste vara en giltig e-postadress';
            toastService.error('Error', message);
        }
    } else {
        toastService.error('Error', 'You must agree to our Terms and Privacy Policy');
    }
});
// $('#submit-subcribe').click(function(e) {
//     e.preventDefault();
//
//     var updateNews = $('#updateNews').is(':checked');
//     var agreeTerm = $('#agreeTerm').is(':checked');
//     var email = $('#email-subcribe').val().toLowerCase();
//
//     if(updateNews && agreeTerm) {
//         if (validateEmail(email)) {
//             var dataForm = {
//                 'email' : email
//             };
//
//             $.ajax({
//                 type:'POST',
//                 url:'/subcribe',
//                 data: dataForm,
//                 success:function(data){
//                     var message = data['message'];
//                     if (data['error']) {
//                         toastService.error('Error', message);
//                     } else {
//                         toastService.success('Success', message);
//                         $('#email-subcribe').val('');
//                     }
//                 }
//             });
//         } else {
//             var message = 'E-post måste vara en giltig e-postadress';
//             toastService.error('Error', message);
//         }
//     } else {
//         toastService.error('Error', 'You must agree to our Terms and Privacy Policy');
//     }
// });

$('#owner-next-step-about-dog').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('#owner-profile');
    var name = form.find('#dog-name').val();
    var breed = form.find('#dog-breed').val();
    var size = form.find('#dog-size').val();
    var month = form.find('#dog-month').val();
    var year = form.find('#dog-year').val();
    var about = form.find('#dog-about').val();
    var regexMonth = /^1[0-2]$|^0[1-9]$/;
    var regex = /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]{1,255}$/;
    form.find('.dog-name').find('.invalid-feedback').html("");
    form.find('#dog-name').get(0).setCustomValidity('');
    if (!name || about.length > 5000 || !regex.test(name) || !breed || !size || ( month &&  !regexMonth.test(month))
        || (year && (parseInt(year) < 1990 || parseInt(year) > 2099))) {
        form.addClass('was-validated');

        if (!name){
            form.find('.dog-name').find('.invalid-feedback').html("Vänligen berätta för din hunds namn.");
        } else if (name && !regex.test(name)){
            form.find('#dog-name').get(0).setCustomValidity('Invalid');
            form.find('.dog-name').find('.invalid-feedback').html("Namn format är ogiltigt.");
        }
        if( about.length > 5000) {
            form.find('.dog-about').find('.invalid-feedback').html("Texten får inte vara större än 5000 tecken.").addClass('active');
        } else {
            form.find('.dog-about').find('.invalid-feedback').removeClass('active');
        }

        if (month && !regexMonth.test(month)) {
            $('.dog-birthday').find('.error-month').addClass('active');
        } else {
            $('.dog-birthday').find('.error-month').removeClass('active');
        }

        if (year && (parseInt(year) < 1990 || parseInt(year) > 2099)) {
            $('.dog-birthday').find('.error-year').addClass('active');
        } else {
            $('.dog-birthday').find('.error-year').removeClass('active');
        }

        if (!breed) {
            $('.dog-breed').find('.error-breed').addClass('active');
        } else {
            $('.dog-breed').find('.error-breed').removeClass('active');
        }
        return;
    } else {
        form.removeClass('was-validated');
        $.ajax({
            url:'/register/extractDogName',
            type:'POST',
            data:{
                name:name
            },
            dataType:'json',
            success:function(data){
                $('.owner-step-picture-dog p').first().html(data.intro_dog_pic);
                $('.hobby p').html(data.dog_would_like);
                $('.character p').html(data.dog_is);
                $('.concordant p').html(data.dog_get_well);
                $('.availability p').html(data.dog_available);
                $('.insurance p').html(data.dog_insurance);
                $('.owner-step-dog-profile').addClass('inactive');
                $('.owner-step-picture-dog').addClass('active');
            }
        });
        // $('.owner-step-about-dog').find('h3').empty();
        // $('.owner-step-about-dog').find('h3').append('TELL US SOMETHING ABOUT '+ name);
    }
});

// $('#owner-back-step-dog-profile').on('click', function (e) {
//     e.preventDefault();
//     var form = $(this).closest('#owner-profile');
//     $('.owner-step-about-dog').removeClass('active');
//     $('.owner-step-dog-profile').removeClass('inactive');
//     form.removeClass('was-validated');
// });
//
// $('#owner-next-step-picture-dog').on('click',function (e) {
//     e.preventDefault();
//     var form = $(this).closest('#owner-profile');
//     var about = form.find('#dog-about').val();
//     if(!about){
//         form.addClass('was-validated');
//         return;
//     } else {
//         form.removeClass('was-validated');
//         $('.owner-step-about-dog').removeClass('active');
//         $('.owner-step-picture-dog').addClass('active');
//     }
// });

$('#owner-back-step-about-dog').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('#owner-profile');
    $('.owner-step-picture-dog').removeClass('active');
    $('.owner-step-dog-profile').removeClass('inactive');
    form.removeClass('was-validated');
});

$('#owner-next-step-property').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('#owner-profile');
    var parent = $(this).closest('.owner-step-picture-dog.active');
    var inputFile = parent.find('#profile_photo_dog');
    if (inputFile.prop('files').length == 0){
        form.addClass('was-validated');
        $('#profile_photo_dog').get(0).setCustomValidity('Invalid');
        return;
    } else {
        uploadPreviewDog.croppie('result', config_croppie_picture).then(function (resp) {
            $('#save-cropped-avatar-dog').val(resp);
            //console.log($('#save-cropped-avatar-dog').val());
            form.removeClass('was-validated');
            $('#profile_photo_dog').get(0).setCustomValidity('');
            $('.owner-step-picture-dog').removeClass('active');
            $('.owner-step-extras').addClass('active');
        });
    }
    if (form.find('.owner-step-extras').find('.checkbox-step').length == 0){
        $.ajax({
            type:'GET',
            url: '/register/properties/owner',
            dataType:'json',
            success:function(data){
                $.each(data,function (key,value) {
                    $.each(value,function (k,v) {
                        $('.owner-step-extras').find('.'+key).append(
                            '<div class="checkbox-step">' +
                                '<label class="checkbox-inline" for="' + key + v.id +'">' +
                                    '<input type="checkbox" id="' + key + v.id +'" name="' + key + v.id +'" value="'+ v.id +'"><span>'+ v.name + '</span>' +
                                '</label>' +
                            '</div>');
                    })
                });
            }
        });
    }
});

$('#owner-skip-step-picture-dog').on('click',function (e) {
    e.preventDefault();
    $('#profile_photo_dog').val('');
    $("#uploadPreviewDog").attr('src', base_url+'/images/upload-photo.png') ;
    var form = $(this).closest('#owner-profile');
    form.removeClass('was-validated');
    $('.owner-step-picture-dog').removeClass('active');
    $('.owner-step-extras').addClass('active');
    if (form.find('.owner-step-extras').find('.checkbox-step').length == 0){
        $.ajax({
            type:'GET',
            url: '/register/properties/owner',
            dataType:'json',
            success:function(data){
                $.each(data,function (key,value) {
                    $.each(value,function (k,v) {
                        $('.owner-step-extras').find('.'+key).append(
                            '<div class="checkbox-step">' +
                                '<label class="checkbox-inline" for="' + key + v.id +'">' +
                                    '<input type="checkbox" id="' + key + v.id +'" name="' + key + v.id +'" value="'+ v.id +'"><span>'+ v.name + '</span>' +
                                '</label>' +
                            '</div>');
                    })
                });
            }
        });
    }
});

$('#owner-back-step-picture-dog').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('#owner-profile');
    $('.owner-step-extras').removeClass('active');
    $('.owner-step-picture-dog').addClass('active');
    form.find('.owner-step-extras').find('.message-error').hide();
});

$('#owner-next-step-owner-profile').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('#owner-profile');
    var hobby = form.find('.hobby').find('input:checked');
    var character = form.find('.character').find('input:checked');
    var concordant = form.find('.concordant').find('input:checked');
    var availability = form.find('.availability').find('input:checked');
    form.find('.owner-step-extras').find('.message-error').hide();
    if (hobby.length == 0) {
        form.find('.hobby').find('.message-error').show();
    }
    // if (character.length == 0) {
    //     form.find('.character').find('.message-error').show();
    // }
    // if (concordant.length == 0) {
    //     form.find('.concordant').find('.message-error').show();
    // }
    if (availability.length == 0) {
        form.find('.availability').find('.message-error').show();
    }
    if (hobby.length == 0 || availability.length == 0) return;
    form.find('.owner-step-extras').removeClass('active');
    form.find('.owner-step-profile').addClass('active');
});

$('#owner-back-step-extras').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('#owner-profile');
    $('.owner-step-profile').removeClass('active');
    $('.owner-step-extras').addClass('active');
    form.removeClass('was-validated');
});

var submit_owner_load = false;
$('#owner-profile').on('click','#submit-form-owner',function (e) {

    e.preventDefault();
    if (submit_owner_load) return;
    submit_owner_load = true;
    var form = $(this).closest('#owner-profile');
    var loading_submit_owner = form.find('#submit-form-owner #loading-submit-owner > i');
    loading_submit_owner.removeClass('not-processing');
    form.removeClass('was-validated');
    var dataForm = new FormData();
    dataForm.append( 'name', form.find('#dog-name').val() );
    dataForm.append( 'breed', form.find('#dog-breed').val());
    dataForm.append( 'size', form.find('#dog-size').val());
    dataForm.append( 'about', form.find('#dog-about').val() );

    var month = form.find('#dog-month').val();
    var year = form.find('#dog-year').val();

    var day_owner = form.find('#owner-day').val();
    var month_owner = form.find('#owner-month').val();
    var year_owner = form.find('#owner-year').val();
    var error_day = form.find('.error-owner-day');
    var error_month = form.find('.error-owner-month');
    var error_year = form.find('.error-owner-year');
    if ((  day_owner==="" || !regexDay.test(day_owner)) || (month_owner==="" || !regexMonth.test(month_owner)) || ( checkage(year_owner) === false || year_owner==="" ) ){
        form.addClass('was-validate');
        if ( day_owner==="" || !regexDay.test(day_owner)) {
            error_day.show();
        }
        else {
            error_day.hide();
        }
        if (month_owner === "" || !regexMonth.test(month_owner)) {
            error_month.show();
        }
        else {
            error_month.hide();
        }
        if (year_owner === "" || checkage(year_owner) === false ) {
            error_year.show();
        }
        else {
            error_year.hide();
        }

    }
    var birth_owner = year_owner+'-'+month_owner+'-'+day_owner;

    if(month && year){
        dataForm.append( 'birth', form.find('#dog-year').val() + '-' + form.find('#dog-month').val() + '-01');
    }else if (month && !year) {
        dataForm.append( 'birth', '1990-' + form.find('#dog-month').val() + '-01');
    } else if(!month && year){
        dataForm.append( 'birth', form.find('#dog-year').val() + '-01-01');
    }

    if (form.find('#save-cropped-avatar-dog').val()) {
        dataForm.append( 'dog_photo', form.find('#save-cropped-avatar-dog').val());
    }

    form.find('.hobby').find('input:checked').each(function () {
        dataForm.append( 'hobby[]', $(this).val());
    });

    form.find('.character').find('input:checked').each(function () {
        dataForm.append( 'character[]', $(this).val());
    });

    form.find('.concordant').find('input:checked').each(function () {
        dataForm.append( 'concordant[]', $(this).val());
    });

    form.find('.availability').find('input:checked').each(function () {
        dataForm.append( 'availability[]', $(this).val());
    });

    form.find('.insurance').find('input:checked').each(function () {
        dataForm.append( 'insurance', $(this).val());
    });

    dataForm.append('year_owner',year_owner);
    dataForm.append('owner_birth', birth_owner);

    dataForm.append( 'owner_about', form.find('#owner-about').val() );
    // $('.owner-birthday').get(0).setCustomValidity('');
    $('#owner-about').get(0).setCustomValidity('');
    form.find('.invalid-feedback').remove();

    var inputFile = form.find('#profile_photo_owner');
    if (inputFile.prop('files').length !== 0){
        uploadPreviewOwner.croppie('result', config_croppie_picture).then(function (resp) {
            dataForm.append( 'owner_photo', resp);
            register();
        });
    } else {
        register();
    }
    function register() {
        $.ajax({
            type:'POST',
            url:'/register/owner',
            data: dataForm,
            cache: false,
            dataType:'json',
            processData: false,
            contentType : false,
            success:function(data){
                submit_owner_load = true;
                $('#owner-info').modal('hide');
                window.location = data.path;
                loading_submit_owner.addClass('not-processing');
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'finish-creating-profile'
                });
            },
            error: function(data){
                loading_submit_owner.addClass('not-processing');
                submit_owner_load = false;
                form.addClass('was-validated');
                $.each(data.responseJSON.message,function (k,v) {
                    if (k === 'owner_birth') {
                        $('#owner-info').find('.error-birth-owner').html(v);
                        // $( "<div class='invalid-feedback'>" + v + "</div>" ).insertAfter($('.small-note'));
                        // $('.owner-birthday').get(0).setCustomValidity('invalid');
                    } else if (k === 'owner_about') {
                        $( "<div class='invalid-feedback'>" + v + "</div>" ).insertAfter($('#owner-about'));
                        $('#owner-about').get(0).setCustomValidity('invalid');
                    }
                    else if (k==='dog_exist'){
                        toastService.error('Error', v );
                        $('#owner-info').modal('hide');
                    }
                });

            }
        });
    }
});

var uploadPreviewDog = $('#upload-preview-dog').croppie({
    enableExif: true,
    viewport: window.viewport_avatar_size,
    boundary: window.boundary_avatar_size,
    enableOrientation: true
});
$("#upload-preview-dog").hide();

let activeRotateButtonPreviewDog = false;
$('#profile_photo_dog').on('change',function () {
    if(!activeRotateButtonPreviewDog) {
        activeRotateButtonPreviewDog = true;
        setRotateBtn(uploadPreviewDog);
    }
    // var form = $(this).closest('#owner-profile');
    // var val = form.find('#profile_photo_dog').val();
    // switch(val.substring(val.lastIndexOf('.') + 1).toLowerCase()){
    //     case 'gif': case 'jpg': case 'png' : case 'bmp':
    //     form.removeClass('was-validated');
    //     $('#profile_photo_dog').get(0).setCustomValidity('');
    //     PreviewImage('profile_photo_dog','uploadPreviewDog');
    //     break;
    //     default:
    //         $(this).val('');
    //         $("#uploadPreviewDog").attr('src', base_url+'/images/upload-photo.png') ;
    //         // alert("Please choose a picture");
    //         break;
    // }
    if (this.files[0].size > maxSize) {
        $(this).val("");
        alert("Your photo is too large, must be less than 5 Mb");
        return;
    } else {
        $("#upload-preview-dog").show();
        $("#uploadPreviewDog").hide();
        var reader = new FileReader();
        reader.onload = function (e) {
            uploadPreviewDog.croppie('bind', {
                url: e.target.result
            }).then(function () {

            });
        };
        reader.readAsDataURL(this.files[0]);
    }
});

var uploadPreviewAvatar = $('#upload-preview-avatar').croppie({
    enableExif: true,
    viewport: window.viewport_avatar_size,
    boundary: window.boundary_avatar_size,
    enableOrientation: true
});

$("#upload-preview-avatar").hide();
$('#profile_photo_borrower').on('change',function () {
    if(!activeRotateButton) {
        activeRotateButton = true;
        setRotateBtn(uploadPreviewAvatar);
    }
    // var form = $(this).closest('#borrower-profile');
    // var val = form.find('#profile_photo_borrower').val();
    // switch(val.substring(val.lastIndexOf('.') + 1).toLowerCase()){
    //     case 'gif': case 'jpg': case 'png' : case 'bmp':
    //     form.removeClass('was-validated');
    //     $('#profile_photo_dog').get(0).setCustomValidity('');
    //     PreviewImage('profile_photo_borrower','uploadPreviewBorrower');
    //     break;
    //     default:
    //         $(this).val('');
    //         $("#uploadPreviewBorrower").attr('src', base_url+'/images/upload-photo-borrower.png') ;
    //         // alert("Please choose a picture");
    //         break;
    // }
    if (this.files[0].size > maxSize) {
        $(this).val("");
        alert("Your photo is too large, must be less than 5 Mb");
        return;
    } else {
        $("#upload-preview-avatar").show();
        $("#uploadPreviewBorrower").hide();
        var reader = new FileReader();
        reader.onload = function (e) {
            uploadPreviewAvatar.croppie('bind', {
                url: e.target.result
            }).then(function () {

            });
        };
        reader.readAsDataURL(this.files[0]);
    }
});

var uploadPreviewOwner = $('#upload-preview-owner').croppie({
    enableExif: true,
    viewport: window.viewport_avatar_size,
    boundary: window.boundary_avatar_size,
    enableOrientation: true
});

let activeRotateButtonPreviewOwner = false;
$("#upload-preview-owner").hide();
$('#profile_photo_owner').on('change',function () {
    if(!activeRotateButtonPreviewOwner) {
        activeRotateButtonPreviewOwner = true;
        setRotateBtn(uploadPreviewOwner);
    }
    // var form = $(this).closest('#owner-profile');
    // var val = form.find('#profile_photo_owner').val();
    // switch(val.substring(val.lastIndexOf('.') + 1).toLowerCase()){
    //     case 'gif': case 'jpg': case 'png' : case 'bmp':
    //     form.removeClass('was-validated');
    //     $('#profile_photo_owner').get(0).setCustomValidity('');
    //     PreviewImage('profile_photo_owner','uploadPreviewOwner');
    //     break;
    //     default:
    //         $(this).val('');
    //         $("#uploadPreviewOwner").attr('src', base_url+'/images/upload-photo-borrower.png') ;
    //         // alert("Please choose a picture");
    //         break;
    // }
    if (this.files[0].size > maxSize) {
        $(this).val("");
        alert("Your photo is too large, must be less than 5 Mb");
        return;
    } else {
        $("#upload-preview-owner").show();
        $("#uploadPreviewOwner").hide();
        var reader = new FileReader();
        reader.onload = function (e) {
            uploadPreviewOwner.croppie('bind', {
                url: e.target.result
            }).then(function () {

            });
        };
        reader.readAsDataURL(this.files[0]);
    }
});

$('#next-step-about-borrower').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('#borrower-profile');
    var inputFile = $(this).closest('.step-picture-borrower').find('#profile_photo_borrower');
    if (inputFile.prop('files').length == 0){
        form.addClass('was-validated');
        $('#profile_photo_borrower').get(0).setCustomValidity('Invalid');
        return;
    } else {
        uploadPreviewAvatar.croppie('result', config_croppie_picture).then(function (resp) {
            $('#save-cropped-avatar-borrower').val(resp);
            form.removeClass('was-validated');
            $('#profile_photo_borrower').get(0).setCustomValidity('');
            $('.step-picture-borrower').addClass('inactive');
            $('.step-about-borrower').addClass('active');
        });
    }
});

$('#skip-step-picture-borrower').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('#borrower-profile');
    form.removeClass('was-validated');
    $('#profile_photo_borrower').val('');
    $("#uploadPreviewBorrower").attr('src', base_url+'/images/upload-photo-borrower.png') ;
    $('.step-picture-borrower').addClass('inactive');
    $('.step-about-borrower').addClass('active');
});

$('#borrower-back-step-picture').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('#borrower-profile');
    $('.step-about-borrower').removeClass('active');
    $('.step-picture-borrower').removeClass('inactive');
    form.removeClass('was-validated');
});

let birth_borrower = '';
$('#next-step-extras-borrower').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('#borrower-profile');
    var borrower_day = form.find('#borrower-day').val();
    var borrower_month = form.find('#borrower-month').val();
    var borrower_year = form.find('#borrower-year').val();
    var about = form.find('textarea').val();
    form.removeClass('was-validated');
    var error_borrower = form.find('.error-birth-borrower');
    var error_day = form.find('.error-borrower-day');
    var error_month = form.find('.error-borrower-month');
    var error_year = form.find('.error-borrower-year');
    if ((  borrower_day==="" || !regexDay.test(borrower_day)) ||
        (borrower_month==="" || !regexMonth.test(borrower_month)) ||
        (borrower_year===""  || checkage(borrower_year)==false)){
        form.addClass('was-validate');
        if (borrower_day === "" || !regexDay.test(borrower_day)) {
            error_day.show();
            return;
        }
        else {
            error_day.hide();
        }
        if (borrower_month === "" || !regexMonth.test(borrower_month)) {
            error_month.show();
            return;
        }
        else {
            error_month.hide();
        }
        if (borrower_year === "" || checkage(borrower_year)==false )  {
            error_year.show();
            return
        }
        else {
            error_year.hide();
        }

    }
    birth_borrower = borrower_year +"-"+borrower_month+'-'+borrower_day;
    form.removeClass('was-validated');
    $('.step-about-borrower').removeClass('active');
    $('.step-extras-borrower').addClass('active');
    if (form.find('.step-extras-borrower').find('.checkbox-step').length == 0) {
        $.ajax({
            type: 'GET',
            url: '/register/properties/borrower',
            dataType: 'json',
            success: function (data) {
                $.each(data, function (key, value) {
                    $.each(value, function (k, v) {
                        $('.step-extras-borrower').find('.' + key).append(
                            '<div class="checkbox-step">' +
                            '<label class="checkbox-inline" for="' + key + v.id + '">' +
                            '<input type="checkbox" id="' + key + v.id + '" name="' + key + v.id + '" value="' + v.id + '"><span>' + v.name + '</span>' +
                            '</label>' +
                            '</div>');
                    })
                });
            }
        });
    }

});

$('#borrower-back-step-about').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('#borrower-profile');
    $('.step-extras-borrower').find('.message-error').empty();
    $('.step-extras-borrower').removeClass('active');
    $('.step-about-borrower').addClass('active');
});

var submit_borrower_load = false;
$('#borrower-profile').on('click','#submit-form-borrower',function (e) {
    console.log(birth_borrower);
    e.preventDefault();
    if (submit_borrower_load) return;
    submit_borrower_load = true;
    var form = $(this).closest('#borrower-profile');
    var loadinng_submit_borrower = form.find('#submit-form-borrower #loading-submit-borrower > i');
    loadinng_submit_borrower.removeClass('not-processing');
    var dataForm = new FormData();
    dataForm.append( 'about', form.find('#borrower-about').val() );

    if (form.find('#save-cropped-avatar-borrower').val()) {
        dataForm.append( 'file', form.find('#save-cropped-avatar-borrower').val());
    }

    dataForm.append( 'birth', birth_borrower);

    form.find('.hobby').find('input:checked').each(function () {
        dataForm.append( 'hobby[]', $(this).val());
    });

    form.find('.experience').find('input:checked').each(function () {
        dataForm.append( 'experience[]', $(this).val());
    });

    form.find('.owned').find('input:checked').each(function () {
        dataForm.append( 'owned[]', $(this).val());
    });

    form.find('.availability').find('input:checked').each(function () {
        dataForm.append( 'availability[]', $(this).val());
    });
    $.ajax({
        type:'POST',
        url:'/register/borrower',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            $('#borrower-info').modal('hide');
            window.location = data.path;
            submit_borrower_load = true;
            loadinng_submit_borrower.addClass('not-processing');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'finish-creating-profile'
            });
        },
        error: function(data){
            loadinng_submit_borrower.addClass('not-processing');
            $('.step-extras-borrower').find('.message-error').hide();
            $.each(data.responseJSON.message,function (k,v) {
                $('.step-extras-borrower').find('.'+k).find('.message-error').show();
            });
            submit_borrower_load = false;
        }
    });
});

$('#imOwner').on('click',function (e) {
    e.preventDefault();
    $.ajax({
        type:'POST',
        url:'/register/change',
        data: {
            name: 'owner'
        },
        success:function(data){
            $('#borrower-info').modal('hide');
            $('#borrower-info').on('hidden.bs.modal', function (e) {
                $('#owner-info').modal({
                    keyboard: false,
                    backdrop: 'static',
                    show: true
                });
            });
        }
    });
});

$('#imBorrower').on('click',function (e) {
    e.preventDefault();
    $.ajax({
        type:'POST',
        url:'/register/change',
        data: {
            name: 'borrower'
        },
        success:function(data){
            $('#owner-info').modal('hide');
            $('#owner-info').on('hidden.bs.modal', function (e) {
                $('#borrower-info').modal({
                    keyboard: false,
                    backdrop: 'static',
                    show: true
                });
            })
        }
    });
});

function PreviewImage(input,image) {
    var oFReader = new FileReader();
    oFReader.readAsDataURL(document.getElementById(input).files[0]);
    oFReader.onload = function (oFREvent) {
        document.getElementById(image).src = oFREvent.target.result;
    };
}

var galleryTop = new Swiper('.gallery-top', {
    direction: 'vertical',
    height: 335,
    allowTouchMove: false
});
var count_swiper_slide = $('.count-swiper-slide').val();
if (count_swiper_slide > 3) {
    count_swiper_slide = 3
}
var galleryThumbs = new Swiper('.gallery-thumbs', {
    direction: 'vertical',
    slidesPerView: count_swiper_slide,
    height: 125*count_swiper_slide,
    slideToClickedSlide: true,
    loop: count_swiper_slide > 1 ? true : false,
});
galleryThumbs.on('slideChange', function () {
    var swiperPage = galleryThumbs.realIndex;
    galleryTop.slideTo(swiperPage);
    $('.gallery-thumbs .swiper-slide').removeClass('.swiper-slide-active');
    $(this).addClass('swiper-slide-active')
});
// var count = 0;
// $('.swiper-slide').on('click', function () {
//     count++;
//     var swiperPage = $('.swiper-slide').length;
//     if (count >= swiperPage) {
//         count = 0;
//     }
//     galleryThumbs.slideTo(count);
//     $('.gallery-thumbs .swiper-slide').removeClass('.swiper-slide-active');
//     $(this).addClass('swiper-slide-active')
// })
//Share fb

$('.fb-share').click(function(e) {
    e.preventDefault();
    window.open($(this).attr('href'), 'Facebook', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    return false;
});

//Share twiter
$('.twiter-share').click(function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    window.open($(this).attr('href'), 'Twitter', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    return false;
});

//Share G+
$('.google-share').click(function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    window.open($(this).attr('href'), 'Google', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    return false;
});

$(".wrap-content-message").scrollTop($(".wrap-content-message").prop("scrollHeight"));

$('#submit-message').click(function(e) {
    e.preventDefault();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    var content = $('#compose-message').val();
    var receiverId = $('#user-received').val();
    if (receiverId == 0) return;
    if (content.trim() == '') {
        toastService.error('Error', 'message is not null');
        return
    }
    var dataForm = {
        'content' : content,
        'receiverId' : receiverId
    };

    $.ajax({
        type:'POST',
        url:'/sendMessage',
        data: dataForm,
        success:function(data){
            toastService.success('', data.message_success);
            var date = data['created_at'].substring(0, 10);
            var html = '<div class="content text-right">' +
                            '<div class="message">'+
                                '<div>' +
                                    '<div class="descriptions-right">'+
                                        '<span>'+ data.content +'</span>'+
                                    '</div>'+
                                    '<p class="desciption-time-right">' + data.message_time + '</p>' +
                                '</div>' +
                                '<div class="images-author">'+
                                    '<img alt="author" src="'+ data.images +'"  class="author-images-circle">'+
                                '</div>'+
                            '</div>'+
                        '</div>';
            $(".wrap-content-message").append(html).animate({ scrollTop: $('.wrap-content-message').prop("scrollHeight")}, 1000);
            $('#compose-message').val('');
        },
        error: function(err) {
            console.log(err)
        }
    });
});

$('#list-users').on('click','.message-banner', {} ,function(e){
    e.preventDefault();
    $('.left-menu-message .message-banner.active').removeClass('active');
    $(this).closest('.message-banner').addClass('active');
    var id = $(this).attr('user-conversion');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var dataForm = {
        'receiverId' : id
    };

    $.ajax({
        type:'POST',
        url:'/message/read',
        data: dataForm,
        success:function(data){
            var contentMessages = data.content;
            var userLogin = data.userLogin;
            var receiverUser = data.receiverUser;

            var viewContentMessage = '';

            var memberAvatar = receiverUser.avatar ? base_url + '/storage/avatar/' + receiverUser.avatar : base_url + '/images/default.png';
            var nameMember = '<div class="images-author">' +
                '<a href="' + receiverUser.link_profile + '">' +
                '<img alt="author" src="' + memberAvatar + '" class="author-images-circle">' +
                '</a>' +
                '</div>' +
                '<div class="name">' +
                '<a class="bold" href="' + receiverUser.link_profile + '">' +
                '<span>' + receiverUser.first_name + '</span>' +
                '</a>' +
                '</div>' +
                '<input type="hidden" id="user-received" value="' + receiverUser.id + '">';

            if(contentMessages.length > 0) {
                contentMessages.forEach(function(item, index) {

                    if(userLogin.id === item.sender_id) {
                        let image = userLogin.avatar ? base_url + '/storage/avatar/' + userLogin.avatar : base_url + '/images/default.png';
                        let link_profile = "";
                        if(userLogin.role_id === 4) {
                            link_profile = base_url + '/detail/dog/' + userLogin.id;
                        }else if(userLogin.role_id === 3) {
                            link_profile = base_url + '/detail/borrower/' + userLogin.id;
                        }

                        viewContentMessage += '<div class="content text-right">' +
                            '<div class="message">' +
                            '<div>' +
                            '<div class="descriptions-right">' +
                            '<span>' + item.content + '</span>' +
                            '</div>' +
                            '<p class="desciption-time-right">' + item.message_time + '</p>' +
                            '</div>' +
                            '<div class="images-author">' +
                            '<a href="' + link_profile + '">' +
                            '<img alt="author" src="' + image + '" class="author-images-circle">' +
                            '</a>' +
                            '</div>' +
                            '</div>' +
                            '</div>'
                    } else {
                        let image = receiverUser.avatar ? base_url + '/storage/avatar/' + receiverUser.avatar : base_url + '/images/default.png';

                        viewContentMessage += '<div class="content text-left">' +
                            '<div class="message">' +
                            '<div class="images-author">' +
                            '<a href="' + receiverUser.link_profile + '">' +
                            '<img alt="author" src="' + image + '" class="author-images-circle">' +
                            '</a>' +
                            '</div>' +
                            '<div>' +
                            '<div class="descriptions-left">' +
                            '<span>' + item.content + '</span>' +
                            '</div>' +
                            '<p class="desciption-time-left">' + item.message_time + '</p>' +
                            '</div>' +
                            '</div>' +
                            '</div>'
                    }
                });
            }


            $('#wrap-main-message').find(".name-member-message").html(nameMember);
            $('#wrap-main-message').find(".wrap-content-message").html(viewContentMessage).scrollTop($(".wrap-content-message").prop("scrollHeight"));
        }
    });
});

$('.search-user').selectize({
    placeholder: 'Kontakter'
});

$('#user-selected').change(function(e) {
    e.preventDefault();
    var value = $(this).val();
    var dataForm = {
        'receiverId' : value
    };
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.ajax({
        type:'POST',
        url:'/newMessage',
        data: dataForm,
        success:function(data){
            $("#list-users").html(data);
        }
    });

    $.ajax({
        type:'POST',
        url:'/message/read',
        data: dataForm,
        success:function(data){
            console.log(data)
            $("#main-message").html(data);
            $(".search-user").val('');
        }
    });
});

$('.search-breed').selectize({
    options: breedList,
    labelField: 'name',
    searchField: 'name',
    valueField: 'name',
    placeholder: 'Sök en hundras'
});

$('body').on('click','.favorite-dog', function (e) {
    e.preventDefault();
    var button = $(this);
    var dogID = button.attr('dog-id');
    $.ajax({
        type:'POST',
        url:'/setFavoritesDog/' + dogID,
        success:function(){
            if (button.hasClass('icon-dog-foot-gray')) {
                button.removeClass('icon-dog-foot-gray').addClass('icon-dog-foot-red');
                button.attr('data-original-title', 'Unlike');
            } else {
                button.removeClass('icon-dog-foot-red').addClass('icon-dog-foot-gray');
                button.attr('data-original-title', 'Like');
            }
        },
        error: function (data) {

        }
    });
});


$('body').on('click','.favorite-borrower', function (e) {

    e.preventDefault();
    var button = $(this);
    var borrowerID = button.attr('borrower-id');
    $.ajax({
        type:'POST',
        url:'/setFavoritesBorrower/' + borrowerID,
        success:function(){
            if (button.hasClass('icon-dog-foot-gray')) {
                button.removeClass('icon-dog-foot-gray').addClass('icon-dog-foot-red');
                // button.attr('data-original-title', 'Unlike');
            } else {
                button.removeClass('icon-dog-foot-red').addClass('icon-dog-foot-gray');
                // button.attr('data-original-title', 'Like');
            }
        },
        error: function (data) {

        }
    });
});

$('#forgot-password').on('click',function (e) {
    e.preventDefault();
    var button = $(this);
    button.closest('#sign-in').addClass('inactive');
    button.closest('.content').find('.forgot-password').addClass('active');
});

var pending_email = false;
$('#forgot-password-button').on('click',function (e) {
    e.preventDefault();
    if (pending_email) return;
    pending_email = true;
    var form = $(this).closest('form');
    var dataForm = {
        'email' : form.find('#email-forgot').val(),
    };
    form.removeClass('was-validated');
    form.find('#email-forgot').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/password/email',
        data: dataForm,
        success:function(data){
            pending_email = false;
            $('.forgot-password').removeClass('active');
            $('.send-success-email').addClass('active');
        },
        error:function (data) {
            pending_email = false;
            form.addClass('was-validated');
            form.find('#email-forgot').get(0).setCustomValidity('Invalid');
        }
    });
});

var reset_password = false;
$('#reset-password').on('click',function (e) {
    e.preventDefault();
    if (reset_password) return;
    reset_password = true;
    var button = $(this);
    var form = $(this).closest('form');
    var dataForm = {
        'email' : form.find('#email-reset').val(),
        'password' : form.find('#password-reset').val(),
        'password_confirmation' : form.find('#password-confirm').val(),
        'token': form.find('input[name="token"]').val(),
    };
    form.find('.message-error').removeClass('active');
    $.ajax({
        type:'POST',
        url:'/password/reset',
        data: dataForm,
        success:function(data){
            reset_password = false;
            window.location = window.location.origin;
        },
        error:function (data) {
            reset_password = false;
            form.find('.message-error').addClass('active');
        }
    });
});
$('#general-borrower').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.general-borrower').addClass('active');
});

$('#avatar-borrower-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.borrower-profile').addClass('active');
    $content.find('.borrower-profile').find('.avatar-borrower').addClass('active');
});

$('#about-borrower-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.borrower-profile').addClass('active');
    $content.find('.borrower-profile').find('.about-borrower').addClass('active');
});

$('#extras-borrower-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.borrower-profile').addClass('active');
    $content.find('.borrower-profile').find('.extras-borrower').addClass('active');
});

$('#password-borrower').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.borrower-profile').addClass('active');
    $content.find('.borrower-profile').find('.password-borrower').addClass('active');
});

var findLocationBorrower = false;
$('body').on('findLocationBorrower',function () {
    if (findLocationBorrower) return;
    findLocationBorrower = true;
    var form = $('#general-borrower-form');
    var dataForm = {
        'first_name' : form.find('#first-name-general-borrower').val(),
        'last_name' : form.find('#last-name-general-borrower').val(),
        'phone_number' : form.find('#phone-number-general-borrower').val(),
        'location' : form.find("input[name='location_id_general_borrower']").val(),
        'location_lat' : form.find("input[name='location_lat_general_borrower']").val(),
        'location_lng' : form.find("input[name='location_lng_general_borrower']").val(),
        'location_address' : form.find("input[name='location_address_general_borrower']").val(),
        'location_address_detail' : form.find("input[name='location_address_detail_general_borrower']").val(),
    };
    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#location-general-borrower').get(0).setCustomValidity('');
    $('#first-name-general-borrower').get(0).setCustomValidity('');
    $('#last-name-general-borrower').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/borrower/saveGeneral',
        data: dataForm,
        dataType:'json',
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
            findLocationBorrower = false;
        },
        error: function (data) {
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if(key == 'location'){
                    $( "<div class='invalid-feedback'>Vänligen ange adress inom Sverige</div>" ).insertAfter($('#location-general-borrower'));
                    $('#location-general-borrower').get(0).setCustomValidity('invalid');
                } else if (key == 'first_name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#first-name-general-borrower'));
                    $('#first-name-general-borrower').get(0).setCustomValidity('invalid');
                } else if (key == 'last_name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#last-name-general-borrower'));
                    $('#last-name-general-borrower').get(0).setCustomValidity('invalid');
                } else if (key == 'phone_number'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#phone-number-general-borrower'));
                    $('#phone-number-general-borrower').get(0).setCustomValidity('invalid');
                }
            });
            findLocationBorrower = false;
        }
    })
});

var uploadBorrowerAvatar = $('#upload-borrower-avatar').croppie({
    enableExif: true,
    viewport: window.viewport_avatar_size,
    boundary: window.boundary_avatar_size,
    enableOrientation: true
});

$("#upload-borrower-avatar").hide();
$('#avatar-profile-borrower').on('change',function () {
    if(!activeRotateButton) {
        activeRotateButton = true;
        setRotateBtn(uploadBorrowerAvatar);
    }
    // var form = $(this).closest('form');
    // var val = form.find('#avatar-profile-borrower').val();
    // switch(val.substring(val.lastIndexOf('.') + 1).toLowerCase()){
    //     case 'gif': case 'jpg': case 'png' : case 'bmp':
    //     form.removeClass('was-validated');
    //     $('#avatar-profile-borrower').get(0).setCustomValidity('');
    //     PreviewImage('avatar-profile-borrower','uploadPreviewProfileBorrower');
    //     break;
    //     default:
    //         $(this).val('');
    //         $("#uploadPreviewProfileBorrower").attr('src', base_url+'/storage/avatar/'+$("#uploadPreviewProfileBorrower").attr('data')) ;
    //         alert("Please choose a picture");
    //         break;
    // }
    if (this.files[0].size > maxSize) {
        $(this).val("");
        alert("Your photo is too large, must be less than 5Mb");
        return;
    } else {
        $("#upload-borrower-avatar").show();
        $("#uploadPreviewProfileBorrower").hide();
        var reader = new FileReader();
        reader.onload = function (e) {
            uploadBorrowerAvatar.croppie('bind', {
                url: e.target.result
            }).then(function () {
                console.log('jQuery bind complete');
            });
        };
        reader.readAsDataURL(this.files[0]);
    }
});

$('#avatar-my-profile-borrower').on('change',function () {
    var dataForm = new FormData();
    var input = $(this);
    dataForm.append('file', $(this)[0].files[0]);
    input.val('');
    $.ajax({
        type:'POST',
        url:'/borrower/savePhoto',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            switch (data.order) {
                case 1: $('#photoBigBorrower').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                        $('#photoBigBorrower').closest('.photo').addClass('hasPhoto');
                        $('#big-photo-borrower').removeClass('notPhoto');
                        break;
                case 2: $('#photoLeftBorrower').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                        $('#photoLeftBorrower').closest('.photo').addClass('hasPhoto');
                        $('#left-photo-borrower').removeClass('notPhoto');
                        break;
                case 3: $('#photoLeftCenterBorrower').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                        $('#photoLeftCenterBorrower').closest('.photo').addClass('hasPhoto');
                        $('#left-center-photo-borrower').removeClass('notPhoto');
                        break;
                case 4: $('#photoRightCenterBorrower').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                        $('#photoRightCenterBorrower').closest('.photo').addClass('hasPhoto');
                        $('#right-center-photo-borrower').removeClass('notPhoto');
                        break;
                case 5: $('#photoRightBorrower').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                        $('#photoRightBorrower').closest('.photo').addClass('hasPhoto');
                        $('#right-photo-borrower').removeClass('notPhoto');
                        break;
            }
        },
        error:function (data) {
            console.error(data)
            var message = data['message'];
            toastService.error('Error', message);
        }
    });
});

$('.button-addPhoto-Borrower').on('click','button',function (e) {
    e.preventDefault();
    var button = $('this');
    $('#avatar-my-profile-borrower').trigger('click');
});

$('.button-addPhoto-Borrower').on('dblclick','img',function (e) {
    e.preventDefault();
    var img = $(this);
    var src = img.attr('src');
    var path = img.attr('data-path');
    var srcBigPhoto = $('#photoBigBorrower').attr('src');
    var pathBigPhoto = $('#photoBigBorrower').attr('data-path');
    img.attr('src', srcBigPhoto);
    img.attr('data-path', pathBigPhoto);
    $('#photoBigBorrower').attr('src', src);
    $('#photoBigBorrower').attr('data-path', path);
});

$('.avatar-borrower').find('.photo').on('click','a', function (e) {
    e.preventDefault();
    var $a = $(this);
    var img = $a.closest('.photo').find('img');
    var pr = $('.button-addPhoto-Borrower');
    var data = {
        path: img.attr('data-path')
    };
    $.ajax({
        type:'POST',
        url:'/borrower/removePhoto',
        data: data,
        dataType:'json',
        success:function(data){
            pr.find('.photo').removeClass('hasPhoto');
            pr.find('button').addClass('notPhoto');
            pr.find('img').attr('src', '').attr('data-order', '').attr('data-path', '');
            $.each(data.allPhoto, function (k, v) {
                if (k == 0) {
                    $('#photoBigBorrower').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoBigBorrower').closest('.photo').addClass('hasPhoto');
                    $('#big-photo-borrower').removeClass('notPhoto');
                }
                else if (k == 1) {
                    $('#photoLeftBorrower').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoLeftBorrower').closest('.photo').addClass('hasPhoto');
                    $('#left-photo-borrower').removeClass('notPhoto');
                }
                else if (k == 2) {
                    $('#photoLeftCenterBorrower').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoLeftCenterBorrower').closest('.photo').addClass('hasPhoto');
                    $('#left-center-photo-borrower').removeClass('notPhoto');
                }
                else if (k == 3) {
                    $('#photoRightCenterBorrower').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoRightCenterBorrower').closest('.photo').addClass('hasPhoto');
                    $('#right-center-photo-borrower').removeClass('notPhoto');
                }
                else if (k == 4) {
                    $('#photoRightBorrower').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoRightBorrower').closest('.photo').addClass('hasPhoto');
                    $('#right-photo-borrower').removeClass('notPhoto');
                }
            });
        },
        error: function (data) {
            var message = data['message'];
            toastService.error('Error', message);
        }
    });
});

$('#submit-avatar-borrower').on('click',function (e) {
    e.preventDefault();
    e.stopPropagation();
    uploadBorrowerAvatar.croppie('result', config_croppie_picture
    ).then(function (resp) {
        console.log(resp);
        if($("#upload-borrower-avatar").is(":visible")) {
            $.ajax({
                url: "/borrower/saveCropPicture",
                type: "POST",
                data: {"image": resp},
                success: function (data) {
                    $("#uploadPreviewProfileBorrower").attr('src', resp);
                    $("#upload-borrower-avatar").hide();
                    $("#uploadPreviewProfileBorrower").show();
                    var message = data['message'];

                    toastService.success('Success', message);
                },
                error: function (data) {
                    console.log(data);
                    var message = data['message'];
                    toastService.error('Error', message);
                }
            });
        }
    });
    // var button = $(this);
    // var form = button.closest('form');
    // var dataForm = new FormData();
    //
    // if (form.find('#avatar-profile-borrower').prop('files').length > 0) {
    //     dataForm.append('file', form.find('#avatar-profile-borrower')[0].files[0]);
    // }
    // form.find('.upload-image').find('img').each(function () {
    //     if ($(this).attr('data-path')) {
    //         dataForm.append('photo[' + $(this).attr("data-path") + ']', $(this).attr('data-order'));
    //     }
    // });
    //
    // $.ajax({
    //     type:'POST',
    //     url:'/borrower/savePicture',
    //     data: dataForm,
    //     cache: false,
    //     dataType:'json',
    //     processData: false,
    //     contentType : false,
    //     success:function(data){
    //         var message = data['message'];
    //         $.toast({
    //             heading: 'Success',
    //             text: message,
    //             showHideTransition: 'slide',
    //             icon: 'success',
    //             position: 'top-right'
    //         });
    //     },
    //     error: function (data) {
    //         var message = data['message'];
    //         $.toast({
    //             heading: 'Error',
    //             text: message,
    //             showHideTransition: 'slide',
    //             icon: 'error',
    //             position: 'top-right'
    //         });
    //     }
    // })
});

$('#submit-about-borrower').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var dataForm = new FormData();
    dataForm.append('about', form.find('#borrower-about-profile').val());
    dataForm.append('quote', form.find('#borrower-quote-profile').val());
    if (form.find('#birth-borrower-profile').val()) {
        dataForm.append('birth', form.find('#birth-borrower-profile').val());
    }
    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    if(!IS_PREMEUM_ACCOUNT) {
        $('#birth-borrower-profile').get(0).setCustomValidity('');
    }
    $('#borrower-about-profile').get(0).setCustomValidity('');
    $('#borrower-quote-profile').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/borrower/saveAbout',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
        },
        error: function (data) {
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if (key == 'birth'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#birth-borrower-profile'));
                    $('#birth-borrower-profile').get(0).setCustomValidity('invalid');
                } else if(key == 'about'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#borrower-about-profile'));
                    $('#borrower-about-profile').get(0).setCustomValidity('invalid');
                } else if(key == 'quote'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#borrower-quote-profile'));
                    $('#borrower-quote-profile').get(0).setCustomValidity('invalid');
                }
            });
        }
    })
});

$('#submit-extras-borrower').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var dataForm = new FormData();
    form.find('.hobby').find('input:checked').each(function () {
        dataForm.append( 'hobby[]', $(this).val());
    });

    form.find('.experience').find('input:checked').each(function () {
        dataForm.append( 'experience[]', $(this).val());
    });

    form.find('.owned').find('input:checked').each(function () {
        dataForm.append( 'owned[]', $(this).val());
    });

    form.find('.availability').find('input:checked').each(function () {
        dataForm.append( 'availability[]', $(this).val());
    });
    // $('.extras-borrower').find('.message-error').empty();
    $.ajax({
        type:'POST',
        url:'/borrower/saveExtras',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
        },
        error: function (data) {
            $.each(data.responseJSON.message,function (k,v) {
                $('.extras-borrower').find('.'+k).find('.message-error').show();
            });
        }
    })
});

$('#submit-password-borrower').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var dataForm = new FormData();
    dataForm.append('current_password', form.find('#current-password').val());
    dataForm.append('new_password', form.find('#new-password').val());
    dataForm.append('confirm_password', form.find('#confirm-password').val());

    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#current-password').get(0).setCustomValidity('');
    $('#new-password').get(0).setCustomValidity('');
    $('#confirm-password').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/borrower/changePassword',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
        },
        error: function (data) {
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if (key == 'current_password'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#current-password'));
                    $('#current-password').get(0).setCustomValidity('invalid');
                } else if(key == 'new_password'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#new-password'));
                    $('#new-password').get(0).setCustomValidity('invalid');
                } else if(key == 'confirm_password'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#confirm-password'));
                    $('#confirm-password').get(0).setCustomValidity('invalid');
                }
            });
        }
    })
});

$('#edit-borrower-modal').on('hide.bs.modal', function (e) {
    location.reload();
});

$('#notification-borrower').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.borrower-profile').addClass('active');
    $content.find('.borrower-profile').find('.notification-borrower').addClass('active');
})
$('#membership-borrower-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.borrower-profile').addClass('active');
    $content.find('.membership-borrower').addClass('active');
    $content.find('.update-info-card').addClass('active');
});
$('#showSignupModal').on('click', function (e) {
    e.preventDefault();
    var openSignup = true;
    $('#signinModal').modal('hide').on('hidden.bs.modal', function (e) {
        if (openSignup) {
            $('#signupModal').modal('show');
            openSignup = false;
        }
    });
});showSignupModal

$('#showSigninModal').on('click', function (e) {
    e.preventDefault();
    var openSignin = true;
    $('#signupModal').modal('hide').on('hidden.bs.modal', function (e) {
        if (openSignin) {
            $('#signinModal').modal('show');
            openSignin = false;
        }
    });
});

$('#backSigninModal').on('click', function (e) {
    e.preventDefault();
    var openSignin = true;
    $('#resetPasswordModal').modal('hide').on('hidden.bs.modal', function (e) {
        if (openSignin) {
            $('#signinModal').modal('show');
            openSignin = false;
        }
    });
});
$('#backSignin').on('click',function (e) {
    e.preventDefault();
    var openSignin = true;
    $('#resend-activation-email-modal').modal('hide').on('hidden.bs.modal', function (e) {
        if (openSignin ){
            $('#signinModal').modal('show');
            openSignin = false;
        }
    });
})

$('#showResetPasswordModal').on('click', function (e) {
    e.preventDefault();
    var openResetPassword = true;
    $('#signinModal').modal('hide').on('hidden.bs.modal', function (e) {
        if (openResetPassword) {
            $('#resetPasswordModal').modal('show');
            openResetPassword = false;
        }
    });
});

$('#showResendActivationEmailModal').on('click', function (e) {
    e.preventDefault();
    var openResendActiveEmail = true;
    $('#signinModal').modal('hide').on('hidden.bs.modal', function (e) {
        if (openResendActiveEmail) {
            $('#resend-activation-email-modal').modal('show');
            openResendActiveEmail = false;
        }
    });
});

$('#edit-owner-modal').on('hide.bs.modal', function (e) {
    location.reload();
});

var findLocationOwner = false;
$('body').on('findLocationOwner',function () {
    if (findLocationOwner) return;
    findLocationOwner = true;
    var form = $('#general-owner-form');
    var dataForm = {
        'first_name' : form.find('#first-name-general-owner').val(),
        'last_name' : form.find('#last-name-general-owner').val(),
        'phone_number' : form.find('#phone-number-general-owner').val(),
        'location' : form.find("input[name='location_id_general_owner']").val(),
        'location_lat' : form.find("input[name='location_lat_general_owner']").val(),
        'location_lng' : form.find("input[name='location_lng_general_owner']").val(),
        'location_address' : form.find("input[name='location_address_general_owner']").val(),
        'location_address_detail' : form.find("input[name='location_address_detail_general_owner']").val(),
    };
    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#location-general-owner').get(0).setCustomValidity('');
    $('#first-name-general-owner').get(0).setCustomValidity('');
    $('#last-name-general-owner').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/owner/saveGeneral',
        data: dataForm,
        dataType:'json',
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
            findLocationOwner = false;
        },
        error: function (data) {
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if(key == 'location'){
                    $( "<div class='invalid-feedback'>Vänligen ange adress inom Sverige</div>" ).insertAfter($('#location-general-owner'));
                    $('#location-general-owner').get(0).setCustomValidity('invalid');
                } else if (key == 'first_name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#first-name-general-owner'));
                    $('#first-name-general-owner').get(0).setCustomValidity('invalid');
                } else if (key == 'last_name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#last-name-general-owner'));
                    $('#last-name-general-owner').get(0).setCustomValidity('invalid');
                } else if (key == 'phone_number'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#phone-number-general-owner'));
                    $('#phone-number-general-owner').get(0).setCustomValidity('invalid');
                }
            });
            findLocationOwner = false;
        }
    })
});


var uploadOwnerAvatar = $('#upload-owner-avatar').croppie({
    enableExif: true,
    viewport: window.viewport_avatar_size,
    boundary: window.boundary_avatar_size,
    enableOrientation: true
});

$("#upload-owner-avatar").hide();
$('#avatar-profile-owner').on('change',function () {
    if(!activeRotateButton) {
        activeRotateButton = true;
        setRotateBtn(uploadOwnerAvatar);
    }
    // var form = $(this).closest('form');
    // var val = form.find('#avatar-profile-owner').val();
    // switch(val.substring(val.lastIndexOf('.') + 1).toLowerCase()){
    //     case 'gif': case 'jpg': case 'png' : case 'bmp':
    //     form.removeClass('was-validated');
    //     $('#avatar-profile-owner').get(0).setCustomValidity('');
    //     PreviewImage('avatar-profile-owner','uploadPreviewProfileOwner');
    //     break;
    //     default:
    //         $(this).val('');
    //         $("#uploadPreviewProfileOwner").attr('src', base_url+'/storage/avatar/'+$("#uploadPreviewProfileOwner").attr('data')) ;
    //         alert("Please choose a picture");
    //         break;
    // }
    if (this.files[0].size > maxSize) {
        $(this).val("");
        alert("Your photo is too large, must be less than 5 Mb");
        return;
    } else {
        $("#upload-owner-avatar").show();
        $("#uploadPreviewProfileOwner").hide();
        var reader = new FileReader();
        reader.onload = function (e) {
            uploadOwnerAvatar.croppie('bind', {
                url: e.target.result
            }).then(function () {
                console.log('jQuery bind complete');
            });
        }
        reader.readAsDataURL(this.files[0]);
    }
});

$('#general-owner').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.general-owner').addClass('active');
});

$('#about-owner-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.about-owner').addClass('active');
});

$('#submit-about-owner').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var dataForm = new FormData();
    dataForm.append('about', form.find('#owner-about-profile').val());
    dataForm.append('quote', form.find('#owner-quote-profile').val());
    if (form.find('#birth-owner-profile').val()) {
        dataForm.append('birth', form.find('#birth-owner-profile').val());
    }
    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    if(!IS_PREMEUM_ACCOUNT) {
        $('#birth-owner-profile').get(0).setCustomValidity('');
    }
    $('#owner-about-profile').get(0).setCustomValidity('');
    $('#owner-quote-profile').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/owner/saveAbout',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
        },
        error: function (data) {
            console.log(data)
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if (key == 'birth'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#birth-owner-profile'));
                    $('#birth-owner-profile').get(0).setCustomValidity('invalid');
                } else if(key == 'about'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#owner-about-profile'));
                    $('#owner-about-profile').get(0).setCustomValidity('invalid');
                } else if(key == 'quote'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#owner-quote-profile'));
                    $('#owner-quote-profile').get(0).setCustomValidity('invalid');
                }
            });
        }
    })
});

$('#submit-password-owner').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var dataForm = new FormData();
    dataForm.append('current_password', form.find('#current-password').val());
    dataForm.append('new_password', form.find('#new-password').val());
    dataForm.append('confirm_password', form.find('#confirm-password').val());

    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#current-password').get(0).setCustomValidity('');
    $('#new-password').get(0).setCustomValidity('');
    $('#confirm-password').get(0).setCustomValidity('');
    $.ajax({
        type:'POST',
        url:'/owner/changePassword',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
        },
        error: function (data) {
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if (key == 'current_password'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#current-password'));
                    $('#current-password').get(0).setCustomValidity('invalid');
                } else if(key == 'new_password'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#new-password'));
                    $('#new-password').get(0).setCustomValidity('invalid');
                } else if(key == 'confirm_password'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#confirm-password'));
                    $('#confirm-password').get(0).setCustomValidity('invalid');
                }
            });
        }
    })
});

$('#notification-owner').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.notification-owner').addClass('active');
})

$('#password-owner').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.password-owner').addClass('active');
});

$('#avatar-owner-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.avatar-owner').addClass('active');
});

$('#submit-avatar-owner').on('click',function (e) {
    e.preventDefault();
    e.stopPropagation();
    uploadOwnerAvatar.croppie('result', config_croppie_picture).then(function (resp) {
        if($("#upload-owner-avatar").is(":visible")) {
            $.ajax({
                url: "/owner/saveCropPicture",
                type: "POST",
                data: {"image": resp},
                success: function (data) {
                    $("#uploadPreviewProfileOwner").attr('src', resp);
                    $("#upload-owner-avatar").hide();
                    $("#uploadPreviewProfileOwner").show();
                    var message = data['message'];
                    toastService.success('Success', message);
                }
            });
        }
    });
    // var button = $(this);
    // var form = button.closest('form');
    // var dataForm = new FormData();
    //
    // if (form.find('#avatar-profile-owner').prop('files').length > 0) {
    //     dataForm.append('file', form.find('#avatar-profile-owner')[0].files[0]);
    // }
    //
    // $.ajax({
    //     type:'POST',
    //     url:'/owner/savePicture',
    //     data: dataForm,
    //     cache: false,
    //     dataType:'json',
    //     processData: false,
    //     contentType : false,
    //     success:function(data){
    //         var message = data['message'];
    //         $.toast({
    //             heading: 'Success',
    //             text: message,
    //             showHideTransition: 'slide',
    //             icon: 'success',
    //             position: 'top-right'
    //         });
    //     },
    //     error: function (data) {
    //         var message = data['message'];
    //         $.toast({
    //             heading: 'Error',
    //             text: message,
    //             showHideTransition: 'slide',
    //             icon: 'error',
    //             position: 'top-right'
    //         });
    //     }
    // })
});
$('#membership-owner-profile').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.membership-owner').addClass('active');
    $content.find('.update-info-card').addClass('active');
});

var submit_about_dog = false;
$('#submit-about-dog').on('click',function (e) {
    e.preventDefault();
    if (submit_about_dog) return;
    submit_about_dog = true;
    var form = $(this).closest('form');
    var dataForm = new FormData();

    dataForm.append('name', form.find('#dog-profile-name').val());
    dataForm.append('breed', form.find('#dog-profile-breed').val());
    dataForm.append('size', form.find('#dog-profile-size').val());
    dataForm.append('about', form.find('#dog-profile-about').val());

    var month = form.find('#dog-profile-month').val();
    var year = form.find('#dog-profile-year').val();
    form.removeClass('was-validated');
    form.find('.dog-profile-name').find('.invalid-feedback').remove();
    form.find('.dog-profile-breed').find('.invalid-feedback').remove();
    form.find('.dog-profile-size').find('.invalid-feedback').remove();
    form.find('.dog-profile-about').find('.invalid-feedback').remove();
    $('#dog-profile-name').get(0).setCustomValidity('');
    $('#dog-profile-breed').get(0).setCustomValidity('');
    $('#dog-profile-about').get(0).setCustomValidity('');
    var regexMonth = /^1[0-2]$|^0[1-9]$/;
    var regexYear = /^(19[9-9]\d|20[0-4]\d|2099)$/;
    if ((month && !regexMonth.test(month)) || (year && !regexYear.test(year))) {
        form.addClass('was-validated');

        if (month && !regexMonth.test(month)) {
            $('.dog-profile-birthday').find('.error-dog-month').addClass('active');
        } else {
            $('.dog-profile-birthday').find('.error-dog-month').removeClass('active');
        }

        if (year && !regexYear.test(year)) {
            $('.dog-profile-birthday').find('.error-dog-year').addClass('active');
        } else {
            $('.dog-profile-birthday').find('.error-dog-year').removeClass('active');
        }
        submit_about_dog = false;
        return;
    }

    if ( (month && regexMonth.test(month)) && (year && regexYear.test(year))) {
        form.removeClass('was-validated');
        $('.dog-profile-birthday').find('.error-dog-month').removeClass('active');
        $('.dog-profile-birthday').find('.error-dog-year').removeClass('active');
        dataForm.append('month', month);
        dataForm.append('year', year);
    }

    $.ajax({
        type:'POST',
        url:'/dog/saveAbout',
        data: dataForm,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
            submit_about_dog = false;
        },
        error: function (data) {
            form.addClass('was-validated');
            $.each(data.responseJSON.message, function (key,value) {
                if (key == 'name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#dog-profile-name'));
                    $('#dog-profile-name').get(0).setCustomValidity('invalid');
                } else if (key == 'breed'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#dog-profile-breed'));
                    $('#dog-profile-breed').get(0).setCustomValidity('invalid');
                } else if (key == 'about'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#dog-profile-about'));
                    $('#dog-profile-about').get(0).setCustomValidity('invalid');
                } else if (key == 'size'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#dog-profile-size'));
                    $('#dog-profile-size').get(0).setCustomValidity('invalid');
                }
            });
            submit_about_dog = false;
        }
    })
});

$('#profile-about-dog').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.dog-about-profile').addClass('active');
});

$('#profile-picture-dog').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.dog-picture-profile').addClass('active');
});

$('#profile-extras-dog').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.features');
    $elmPr.find('.active').removeClass('active');
    $(this).addClass('active');
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.active').removeClass('active');
    $content.find('.extras-dog').addClass('active');
});

var uploadDogAvatar = $('#upload-dog-avatar').croppie({
    enableExif: true,
    viewport: window.viewport_avatar_size,
    boundary: window.boundary_avatar_size,
    enableOrientation: true
});

$("#upload-dog-avatar").hide();
$('#profile_picture_dog').on('change',function () {
    if(!activeRotateButton) {
        activeRotateButton = true;
        setRotateBtn(uploadDogAvatar);
    }
    // var form = $(this).closest('form');
    // var val = form.find('#profile_picture_dog').val();
    // switch(val.substring(val.lastIndexOf('.') + 1).toLowerCase()){
    //     case 'gif': case 'jpg': case 'png' : case 'bmp':
    //     form.removeClass('was-validated');
    //     $('#profile_picture_dog').get(0).setCustomValidity('');
    //     PreviewImage('profile_picture_dog','uploadPreviewProfileDog');
    //     break;
    //     default:
    //         $(this).val('');
    //         $("#uploadPreviewProfileDog").attr('src', base_url+'/storage/avatar/dog/'+$("#uploadPreviewProfileDog").attr('data')) ;
    //         alert("Please choose a picture");
    //         break;
    // }
    if (this.files[0].size > maxSize) {
        $(this).val("");
        alert("Your photo is too large, must be less than 5 Mb");
        return;
    } else {
        $("#upload-dog-avatar").show();
        $("#uploadPreviewProfileDog").hide();
        var reader = new FileReader();
        reader.onload = function (e) {
            uploadDogAvatar.croppie('bind', {
                url: e.target.result
            }).then(function () {
                console.log('jQuery bind complete');
            });
        }
        reader.readAsDataURL(this.files[0]);
    }
});

$('#avatar-my-profile-dog').on('change',function () {
    var dataForm = new FormData();
    var input = $(this);
    dataForm.append('file', $(this)[0].files[0]);
    input.val('');
    $.ajax({
        type:'POST',
        url:'/dog/savePhoto',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            data.path += '?' + Math.floor(Math.random() * 10e8);
            switch (data.order) {
                case 1: $('#photoBigDog').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                    $('#photoBigDog').closest('.photo').addClass('hasPhoto');
                    $('#big-photo-dog').removeClass('notPhoto');
                    break;
                case 2: $('#photoLeftDog').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                    $('#photoLeftDog').closest('.photo').addClass('hasPhoto');
                    $('#left-photo-dog').removeClass('notPhoto');
                    break;
                case 3: $('#photoLeftCenterDog').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                    $('#photoLeftCenterDog').closest('.photo').addClass('hasPhoto');
                    $('#left-center-photo-dog').removeClass('notPhoto');
                    break;
                case 4: $('#photoRightCenterDog').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                    $('#photoRightCenterDog').closest('.photo').addClass('hasPhoto');
                    $('#right-center-photo-dog').removeClass('notPhoto');
                    break;
                case 5: $('#photoRightDog').attr('src',data.path).attr('data-order',data.order).attr('data-path',data.pathOrigin);
                    $('#photoRightDog').closest('.photo').addClass('hasPhoto');
                    $('#right-photo-dog').removeClass('notPhoto');
                    break;
            }
        },
        error:function (data) {
            var message = data['message'];
            toastService.error('Error', message);
        }
    });
});

$('.button-addPhoto-Dog').on('click','button',function (e) {
    e.preventDefault();
    var button = $('this');
    $('#avatar-my-profile-dog').trigger('click');
});

$('.button-addPhoto-Dog').on('dblclick','img',function (e) {
    e.preventDefault();
    var img = $(this);
    var src = img.attr('src');
    var path = img.attr('data-path');
    var srcBigPhoto = $('#photoBigDog').attr('src');
    var pathBigPhoto = $('#photoBigDog').attr('data-path');
    img.attr('src', srcBigPhoto);
    img.attr('data-path', pathBigPhoto);
    $('#photoBigDog').attr('src', src);
    $('#photoBigDog').attr('data-path', path);
});

$('.dog-picture-profile').find('.photo').on('click','a', function (e) {
    e.preventDefault();
    var $a = $(this);
    var img = $a.closest('.photo').find('img');
    var pr = $('.button-addPhoto-Dog');
    var data = {
        path: img.attr('data-path')
    };
    $.ajax({
        type:'POST',
        url:'/dog/removePhoto',
        data: data,
        dataType:'json',
        success:function(data){
            pr.find('.photo').removeClass('hasPhoto');
            pr.find('button').addClass('notPhoto');
            pr.find('img').attr('src', '').attr('data-order', '').attr('data-path', '');
            $.each(data.allPhoto, function (k, v) {
                if (k == 0) {
                    $('#photoBigDog').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoBigDog').closest('.photo').addClass('hasPhoto');
                    $('#big-photo-dog').removeClass('notPhoto');
                }
                else if (k == 1) {
                    $('#photoLeftDog').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoLeftDog').closest('.photo').addClass('hasPhoto');
                    $('#left-photo-dog').removeClass('notPhoto');
                }
                else if (k == 2) {
                    $('#photoLeftCenterDog').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoLeftCenterDog').closest('.photo').addClass('hasPhoto');
                    $('#left-center-photo-dog').removeClass('notPhoto');
                }
                else if (k == 3) {
                    $('#photoRightCenterDog').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoRightCenterDog').closest('.photo').addClass('hasPhoto');
                    $('#right-center-photo-dog').removeClass('notPhoto');
                }
                else if (k == 4) {
                    $('#photoRightDog').attr('src', v.path).attr('data-order', v.order).attr('data-path', v.photo);
                    $('#photoRightDog').closest('.photo').addClass('hasPhoto');
                    $('#right-photo-dog').removeClass('notPhoto');
                }
            });
        },
        error: function (data) {
            var message = data['message'];
            toastService.error('Error', message);
        }
    });
});

$('#submit-picture-dog').on('click',function (e) {
    e.preventDefault();
    e.stopPropagation();
    uploadDogAvatar.croppie('result', config_croppie_picture).then(function (resp) {
        if($("#upload-dog-avatar").is(":visible")) {
            $.ajax({
                url: "/dog/saveDogCropPicture",
                type: "POST",
                data: {"image": resp},
                success: function (data) {
                    $("#uploadPreviewProfileDog").attr('src', resp);
                    $("#upload-dog-avatar").hide();
                    $("#uploadPreviewProfileDog").show();
                    var message = data['message'];
                    toastService.success('Success', message);
                }
            });
        }
    });
    // var button = $(this);
    // var form = button.closest('form');
    // var dataForm = new FormData();
    //
    // if (form.find('#profile_picture_dog').prop('files').length > 0) {
    //     dataForm.append('file', form.find('#profile_picture_dog')[0].files[0]);
    // }
    // form.find('.upload-image').find('img').each(function () {
    //     if ($(this).attr('data-path')) {
    //         dataForm.append('photo[' + $(this).attr("data-path") + ']', $(this).attr('data-order'));
    //     }
    // });
    //
    // $.ajax({
    //     type:'POST',
    //     url:'/dog/savePicture',
    //     data: dataForm,
    //     cache: false,
    //     dataType:'json',
    //     processData: false,
    //     contentType : false,
    //     success:function(data){
    //         var message = data['message'];
    //         $.toast({
    //             heading: 'Success',
    //             text: message,
    //             showHideTransition: 'slide',
    //             icon: 'success',
    //             position: 'top-right'
    //         });
    //     },
    //     error: function (data) {
    //         var message = data['message'];
    //         $.toast({
    //             heading: 'Error',
    //             text: message,
    //             showHideTransition: 'slide',
    //             icon: 'error',
    //             position: 'top-right'
    //         });
    //     }
    // })
});

$('#submit-extras-dog').on('click',function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var dataForm = new FormData();
    form.find('.hobby').find('input:checked').each(function () {
        dataForm.append( 'hobby[]', $(this).val());
    });

    form.find('.character').find('input:checked').each(function () {
        dataForm.append( 'character[]', $(this).val());
    });

    form.find('.concordant').find('input:checked').each(function () {
        dataForm.append( 'concordant[]', $(this).val());
    });

    form.find('.availability').find('input:checked').each(function () {
        dataForm.append( 'availability[]', $(this).val());
    });

    form.find('.insurance').find('input:checked').each(function () {
        dataForm.append( 'insurance', $(this).val());
    });
    // $('.extras-dog').find('.message-error').empty();
    $.ajax({
        type:'POST',
        url:'/dog/saveExtras',
        data: dataForm,
        cache: false,
        dataType:'json',
        processData: false,
        contentType : false,
        success:function(data){
            var message = data['message'];
            toastService.success('Success', message);
        },
        error: function (data) {
            $.each(data.responseJSON.message,function (k,v) {
                $('.extras-dog').find('.'+k).find('.message-error').show();
            });
        }
    })
});

$('#edit-dog-profile-modal').on('hide.bs.modal', function (e) {
    location.reload();
});



$('.filter').find('.dropdown-menu').on('click', function(e){
    e.stopPropagation();
});

$('.filter.borrower').find('.dropdown-menu').find('a.dropdown-item').on('click', function(e){
    var item = $(this);
    var form = item.closest('form').attr('class');
    item.closest('.dropdown-menu').find('.dropdown-item.active').removeClass('active');
    item.closest('.btn-group').find('button').html(item.text()+' ');
    item.addClass('active');
    $('body').trigger('search', form);
});

$('.filter.owner').find('.dropdown-menu').find('a.dropdown-item').on('click', function(e){
    var item = $(this);
    var form = item.closest('form').attr('class');
    item.closest('.dropdown-menu').find('.dropdown-item.active').removeClass('active');
    item.closest('.btn-group').find('button').html(item.text()+' ');
    item.addClass('active');
    $('body').trigger('search', form);
});

$('input[name="premium-member"]').on('change',function () {
    var item = $(this);
    var form = item.closest('form');
    var formClass = form.attr('class');
    $('body').trigger('search', formClass);
});

$('.more-filter').find('input').on('change', function () {
    var item = $(this);
    var form = item.closest('form');
    var formClass = form.attr('class');
    $('body').trigger('search', formClass);
});

$('.filter-search').find('.clearAll').on('click', 'a', function () {
    var item = $(this);
    item.closest('.more-filter').find('input').prop( "checked", false );
    var form = item.closest('form');
    var formClass = form.attr('class');
    $('body').trigger('search', formClass);
});

$('body').on('search',function (e, formClass) {
    const form = $('form.' + formClass);
    const searchLat = form.find('.location-search').find('input[name="lat-search"]').val();
    const searchLng = form.find('.location-search').find('input[name="lng-search"]').val();
    const search_address = form.find('.location-search').find('#locationSearch').val();
    const dataForm = new FormData();
    dataForm.append( 'sort', form.find('.sort-by').find('.dropdown-item.active').attr('data-sort'));
    dataForm.append( 'distance', form.find('.distance').find('.dropdown-item.active').attr('data-distance'));
    dataForm.append( 'lat', searchLat);
    dataForm.append( 'lng', searchLng);
    dataForm.append( 'location_address', search_address);
    if (form.find('.premium-search').find('input').is(":checked")) {
        dataForm.append( 'premium', form.find('.premium-search').find('input').is(":checked"));
    }
    form.find('.availability').find('input:checked').each(function () {
        dataForm.append( 'availability[]', $(this).val());
    });

    if (form.closest('.filter').hasClass('borrower')){
        form.find('.good-with').find('input:checked').each(function () {
            dataForm.append( 'concordant[]', $(this).val());
        });
        form.find('.character').find('input:checked').each(function () {
            dataForm.append( 'character[]', $(this).val());
        });
        dataForm.append( 'size', form.find('.size-dog').find('.dropdown-item.active').attr('data-size'));
        form.find('.insurance').find('input:checked').each(function () {
            dataForm.append( 'insurance[]', $(this).val());
        });
        $.ajax({
            type:'POST',
            url:'/search/dog',
            data: dataForm,
            cache: false,
            dataType:'json',
            processData: false,
            contentType : false,
            success:function(data){
                const $filterSearch = form.closest('.filter-search');
                $filterSearch.find('.search-result-count').html(data.dog_found);
                const filterResult = $filterSearch.find('.result-filter');
                filterResult.empty();
                $('body').trigger('search_results', [data, {lat: searchLat, lng: searchLng}]);
                $(function() {
                    $('.rated-bar').each(function (index, el) {
                        var $El = $(el);
                        $El.barrating({
                            theme: 'fontawesome-stars',
                            readonly: true,
                            initialRating: $El.attr('data-current-rating')
                        });
                    });
                });
                $(function() {
                    $('.send-direct-message').on('click', function (e) {
                        e.preventDefault();
                        var send_message = $(this).closest('.send-message');
                        var receiver_name = send_message.find('.user-receive-name').val();
                        var receiver_id = send_message.find('.user-receive-id').val();
                        $('#send-message-modal').modal('show');
                        $('#send-message-modal').find('.receiver-name').html(receiver_name);
                        $('#send-message-modal').find('.receiver-id').val(receiver_id);
                    });
                });
                $.each(data.search, function (key,val) {
                    var imgInsured = '';
                    var sendMessage = '';
                    var rating = '';
                    var num_rated = val.num_rated ? '(' +val.num_rated + ')' : '';

                    if (val.fav){
                        val.favorite = 'icon-dog-foot-red';
                        val.tooltip = 'Unlike';
                    } else {
                        val.favorite = 'icon-dog-foot-gray';
                        val.tooltip = 'Like';
                    }

                    if (val.birth){
                        val.birth = ', '+ val.birth;
                    } else {
                        val.birth= '';
                    }

                    if(val.insurance === 1) {
                        imgInsured = '<img src="' + base_url + '/images/icon_insured_puppy.svg" />';
                    }

                    if(IS_PREMEUM_ACCOUNT) {
                        sendMessage = '<a class="btn btn-send-message title-section send-direct-message">skicka meddelande</a>';
                    } else {
                        sendMessage = '<a class="btn btn-send-message title-section" data-toggle="modal" data-target="#upgrade-premium-modal" data-backdrop="static">skicka meddelande</a>';
                    }
                    rating =showstar.showStars(val.stars,num_rated);
                    filterResult.append(
                            '<div class="col-md-4">' +
                            '    <div class="member-puppy">' +
                            '        <div class="image-puppy">' +
                            '             <a href="' + val.ownerLink + '">' +
                            '                <img alt="dog" src="' + val.avatar +'" class="">' +
                            '             </a>' +
                            '        </div>' +
                            '        <div class="dog-infor">' +
                            '             <div class="header">' +
                            '                 <a href="' + val.ownerLink + '">' +
                            '                   <span class="name capitalize-name">' + firstUpperCase(val.name) + '</span>' +
                            '                 </a>' +
                            '                 <div class="wrap-favorite-button">' +
                            '                   <span dog-id="'+ val.id +'" class="icon favorite-button favorite-dog ' + val.favorite +'" data-toggle="tooltip" data-placement="top" title="'+ val.tooltip +'"></span>' +
                            '                 </div>' +
                            '              </div>' +
                            '              <div class="clearfix"></div>' +
                            '              <div class="introduce">'+ imgInsured + val.breed + val.birth + '</div>' +
                            '              <div class="address">' +
                            '                  <span class="location"><span class="icon icon-pin"></span> &nbsp;'+ val.distance +'</span>' +
                            // '                  <span class="float-right">'+ val.distance +'</span>' +
                            '              </div>' +
                                            rating +
                            '              <div class="membership">' + val.membership + '</div>' +
                            '              <div class="send-message text-center">' +
                            '<input type="hidden" class="user-receive-name" value="' + val.name + '"/>' +
                            '<input type="hidden" class="user-receive-id" value="' + val.owner.id + '"/>' +
                                                sendMessage +
                            '               </div>' +
                            '         </div>' +
                            '    </div>' +
                            '</div>')
                })
            },
            error: function (data) {

            }
        })
    } else {
        form.find('.owned').find('input:checked').each(function () {
            dataForm.append( 'owned[]', $(this).val());
        });
        form.find('.experience').find('input:checked').each(function () {
            dataForm.append( 'experience[]', $(this).val());
        });
        $.ajax({
            type:'POST',
            url:'/search/borrower',
            data: dataForm,
            cache: false,
            dataType:'json',
            processData: false,
            contentType : false,
            success:function(data){
                const $filterSearch = form.closest('.filter-search');
                $filterSearch.find('.search-result-count').html(data.borrower_found);
                const filterResult = $filterSearch.find('.result-filter');
                filterResult.empty();
                $('body').trigger('search_results', [data, {lat: searchLat, lng: searchLng}]);
                $(function() {
                    $('.rated-bar').each(function (index, el) {
                        var $El = $(el);
                        $El.barrating({
                            theme: 'fontawesome-stars',
                            readonly: true,
                            initialRating: $El.attr('data-current-rating')
                        });
                    });
                });
                $(function() {
                    $('.send-direct-message').on('click', function (e) {
                        e.preventDefault();
                        var send_message = $(this).closest('.send-message');
                        var receiver_name = send_message.find('.user-receive-name').val();
                        var receiver_id = send_message.find('.user-receive-id').val();
                        $('#send-message-modal').modal('show');
                        $('#send-message-modal').find('.receiver-name').html(receiver_name);
                        $('#send-message-modal').find('.receiver-id').val(receiver_id);
                    });
                });
                $.each(data.search, function (key,val) {
                    var sendMessage = '';
                    var rating = '';
                    var num_rated = val.num_rated ? '(' +val.num_rated + ')' : '';
                    if(IS_PREMEUM_ACCOUNT) {
                        sendMessage = '<a class="btn btn-send-message title-section send-direct-message">skicka meddelande</a>';
                    } else {
                        sendMessage = '<a class="btn btn-send-message title-section" data-toggle="modal" data-target="#upgrade-premium-modal" data-backdrop="static">skicka meddelande</a>';
                    }
console.log(val.fav)
                    if (val.fav){
                        val.favorite = 'icon-dog-foot-red';
                        val.tooltip = 'Unlike';
                    } else {
                        val.favorite = 'icon-dog-foot-gray';
                        val.tooltip = 'Like';
                    }

                    rating =showstar.showStars(val.stars,num_rated);
                    var name =
                    filterResult.append(
                            '<div class="col-md-4">' +
                            '    <div class="member-puppy">' +
                            '        <div class="image-puppy">' +
                            '               <a href="' + val.borrower + '">' +
                            '                   <img alt="dog" src="' + val.avatar +'" class="">' +
                            '               </a>' +
                            '        </div>' +
                            '        <div class="dog-infor">' +
                            '             <div class="header">' +
                            '               <a href="' + val.borrower + '">' +
                            '                 <span class="name capitalize-name">' + firstUpperCase(val.first_name) + '</span>' +
                            '               </a>' +
                            '                 <div class="wrap-favorite-button">' +
                            '                   <span borrower-id="'+ val.id +'" class="icon favorite-button favorite-borrower ' + val.favorite +'" data-toggle="tooltip" data-placement="top" title="'+ val.tooltip +'"></span>' +
                            '                 </div>' +
                            '              </div>' +
                            '              <div class="clearfix"></div>' +
                            '              <div class="introduce"></div>' +
                            '              <div class="address">' +
                            '                  <span class="location"><span class="icon icon-pin"></span> &nbsp;'+ val.distance +'</span>' +
                            // '                  <span class="float-right">'+ val.distance +'</span>' +
                            '              </div>' +
                                            rating +
                            '              <div class="membership">' + val.membership + '</div>' +
                            '              <div class="send-message text-center">' +
                            '<input type="hidden" class="user-receive-name" value="' + val.first_name + '"/>' +
                            '<input type="hidden" class="user-receive-id" value="' + val.id + '"/>' +
                                                    sendMessage +
                            '               </div>' +
                            '         </div>' +
                            '    </div>' +
                            '</div>')
                })
            },
            error: function (data) {

            }
        })
    }
});
function getStarColor(starPosition, markerStar) {
    if(markerStar) {
        return starPosition <= markerStar ? "#EDB867" : "#d2d2d2";
    }
    return "#d2d2d2";
}



$('.location-search').find('.result-search').on('click', function () {
   $(this).removeClass('active');
   $(this).closest('.location-search').find('.find-location').addClass('active');
});

$('body').on('click',function (e) {
    if ($(e.target).closest('.result-search').length == 0 && $('.find-location.active').length > 0 && $(e.target).closest('.find-location').length == 0){
        $('.location-search').find('.result-search').addClass('active');
        $('.location-search').find('.find-location').removeClass('active');
    }
});

$('.filter-search').find('.btn-group').on('show.bs.dropdown', function () {
    $('.location-search').find('.result-search').addClass('active');
    $('.location-search').find('.find-location').removeClass('active');
});

$('#popular-post-heading').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.wrap-header');
    $elmPr.find('.activeTab').removeClass('activeTab');
    $(this).addClass('activeTab');
    var $content = $(this).closest('.wrap-sidebar').find('.wrap-tab-content');
    $content.find('.active').removeClass('active');
    $content.find('.popular-post').addClass('active');
});

$('#category-heading').on('click',function (e) {
    e.preventDefault();
    var $elmPr = $(this).closest('.wrap-header');
    $elmPr.find('.activeTab').removeClass('activeTab');
    $(this).addClass('activeTab');
    var $content = $(this).closest('.wrap-sidebar').find('.wrap-tab-content');
    $content.find('.active').removeClass('active');
    $content.find('.list-category').addClass('active');
});

$('.list-category').find('li').on('click',function (e) {
    e.preventDefault();
    $('.list-category').find('li').removeClass('activeCategory');
    $(this).addClass('activeCategory');

    var cat_id = $(this).attr('cat-id');
    $.ajax({
        url: "/getPostByCategory",
        type: "POST",
        data: {"cat_id": cat_id},
        success: function (data) {
            var listPost = data['categoryPost'].data;
            $('.wrap-all-story').empty();
            if(listPost.length > 0) {
                $.each(listPost, function (key, val) {
                    var imageUrl = base_url + '/storage/' + val.image;
                    var href = base_url + '/detail/blog/' + val.slug;

                    $('.wrap-all-story')
                        .append(
                            '<div class="row">' +
                                '<div class="col-md-3">' +
                                    '<div class="image-puppy">' +
                                        '<a href="' + href + '">' +
                                            '<img alt="dog-story" src="' + imageUrl + '" class="">' +
                                        '</a>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="col-md-9">' +
                                    '<div class="desciption">' +
                                        '<div>' +
                                            '<a href="' + href + '">' +
                                                '<span class="title-story">' +
                                                    val.title +
                                                '</span>' +
                                            '</a>' +
                                        '</div>' +
                                        '<div class="content">' +
                                            val.excerpt +
                                        '</div>' +
                                        '<div class="read-more top-50">' +
                                            '<a href="' + href + '">READ MORE</a>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>'
                        );
                });
            } else {
                $('.wrap-all-story')
                    .append('<h4>No story has found</h4>');
            }
        }
    });
});

var rating_stars = 1;
$(function() {
    $('#rating-bar').barrating({
        theme: 'fontawesome-stars',
        onSelect: function(value, text, event) {
            if (typeof(event) !== 'undefined') {
                rating_stars = value;
                console.log(value)
            }
        }
    });
});
$(function() {
    var average_stars = $('#average-star').val();
    $('#rated-bar').barrating({
        theme: 'fontawesome-stars',
        readonly: true,
        initialRating: average_stars
    });
});

$(function() {
    $('.rated-bar-homepage').each(function (index, el) {
        var $El = $(el);
        $El.barrating({
            theme: 'fontawesome-stars',
            readonly: true,
            initialRating: $El.attr('data-current-rating')
        });
    });
});

$('body').on('click', '.reply-btn', function(e) {
    e.preventDefault();
    var wrap_comment = $(this).closest('div.wrap-main-comment');
    wrap_comment.find('div.reply-box').show();
});

$('body').on('click', '.cancel-reply-btn', function(e) {
    e.preventDefault();
    var wrap_comment = $(this).closest('div.wrap-main-comment');
    wrap_comment.find('div.reply-box').hide();
});

$('body').on('click', '.like-btn', function(e) {
    e.preventDefault();
    var wrap_action_btn = $(this).closest('div.wrap-action-btn');
    var dislike_btn = wrap_action_btn.find('.dislike-btn');
    var num_like = wrap_action_btn.find('.num_like');
    var num_dislike = wrap_action_btn.find('.num_dislike');
    var comment_id = wrap_action_btn.attr('comment-id');
    var data = {
        'comment_id': comment_id,
        'type': 'like'
    };
    if($(this).hasClass('like-active')) {
        $(this).removeClass('like-active');
        $.ajax({
            type: 'POST',
            url: '/comment/undoActionComment',
            data: data,
            success: function(data) {
                data['like'] > 0 ? num_like.html(data['like']) : num_like.empty();
                data['dislike'] > 0 ? num_dislike.html(data['dislike']) : num_dislike.empty();
            }
        })
    } else {
        if(dislike_btn.hasClass('dislike-active')) {
            dislike_btn.removeClass('dislike-active');
            $(this).addClass('like-active');
            $.ajax({
                type: 'POST',
                url: '/comment/actionComment',
                data: data,
                success: function(data) {
                    data['like'] > 0 ? num_like.html(data['like']) : num_like.empty();
                    data['dislike'] > 0 ? num_dislike.html(data['dislike']) : num_dislike.empty();
                }
            })
        }else {
            $(this).addClass('like-active');
            $.ajax({
                type: 'POST',
                url: '/comment/actionComment',
                data: data,
                success: function(data) {
                    data['like'] > 0 ? num_like.html(data['like']) : num_like.empty();
                    data['dislike'] > 0 ? num_dislike.html(data['dislike']) : num_dislike.empty();
                }
            })
        }
    }
});

$('body').on('click', '.dislike-btn', function(e) {
    e.preventDefault();
    var wrap_action_btn = $(this).closest('div.wrap-action-btn');
    var like_btn = wrap_action_btn.find('.like-btn');
    var num_like = wrap_action_btn.find('.num_like');
    var num_dislike = wrap_action_btn.find('.num_dislike');
    var comment_id = wrap_action_btn.attr('comment-id');
    var data = {
        'comment_id': comment_id,
        'type': 'dislike'
    };
    if($(this).hasClass('dislike-active')) {
        $(this).removeClass('dislike-active');
        $.ajax({
            type: 'POST',
            url: '/comment/undoActionComment',
            data: data,
            success: function(data) {
                data['like'] > 0 ? num_like.html(data['like']) : num_like.empty();
                data['dislike'] > 0 ? num_dislike.html(data['dislike']) : num_dislike.empty();
            }
        })
    } else {
        if(like_btn.hasClass('like-active')) {
            like_btn.removeClass('like-active');
            $(this).addClass('dislike-active');
            $.ajax({
                type: 'POST',
                url: '/comment/actionComment',
                data: data,
                success: function(data) {
                    data['like'] > 0 ? num_like.html(data['like']) : num_like.empty();
                    data['dislike'] > 0 ? num_dislike.html(data['dislike']) : num_dislike.empty();
                }
            })
        }else {
            $(this).addClass('dislike-active');
            $.ajax({
                type: 'POST',
                url: '/comment/actionComment',
                data: data,
                success: function(data) {
                    data['like'] > 0 ? num_like.html(data['like']) : num_like.empty();
                    data['dislike'] > 0 ? num_dislike.html(data['dislike']) : num_dislike.empty();
                }
            })
        }
    }
});

var loading_submit_reply = false;
$('body').on('click', '.submit-reply-btn', function(e) {
    e.preventDefault();
    if (loading_submit_reply) return;
    loading_submit_reply = true;
    var formData = new FormData();
    var form = $(this).closest('form');
    formData.append('name', $('#reply-name').val());
    formData.append('email', $('#reply-email').val());
    formData.append('avatar', $('#reply-avatar').val());
    formData.append('message', form.find('.reply-message').val());
    formData.append('comment_id', form.find('.comment-id').val());
    formData.append('profile_id', $('#profile-id').val());

    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    var reply_message = form.find('.reply-message')
    reply_message.get(0).setCustomValidity('');
    $.ajax({
        type: 'POST',
        url: '/comment/sendReply',
        data: formData,
        processData: false,
        contentType: false,
        success: function(data) {
            var message = data['message'];
            toastService.success('Success', message);
            loading_submit_reply = false;
            location.reload();
        },
        error: function(error) {
            form.addClass('was-validated');
            $.each(error.responseJSON.message, function (key,value) {
                if (key == 'message'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter(reply_message);
                    reply_message.get(0).setCustomValidity('invalid');
                }
            });
            loading_submit_reply = false;
        }
    })
});

var loading_submit_comment = false;
$('body').on('click', '#submit-comment', function(e) {
    e.preventDefault();
    if (loading_submit_comment) return;
    loading_submit_comment = true;
    var formData = new FormData();
    var form = $(this).closest('form');
    formData.append('name', form.find('#comment-name').val());
    formData.append('email', form.find('#comment-email').val());
    formData.append('message', form.find('#comment-message').val());
    formData.append('avatar', $('#reply-avatar').val());
    formData.append('profile_id', $('#profile-id').val());
    formData.append('stars', rating_stars);

    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#comment-email').get(0).setCustomValidity('');
    $('#comment-name').get(0).setCustomValidity('');
    $('#comment-message').get(0).setCustomValidity('');

    $.ajax({
        type: 'POST',
        url: '/comment/sendComment',
        data: formData,
        processData: false,
        contentType: false,
        success: function(data) {
            var message = data['message'];
            toastService.success('Success', message);
            loading_submit_comment = false;
            location.reload();
        },
        error: function(error) {
            form.addClass('was-validated');
            $.each(error.responseJSON.message, function (key,value) {
                if (key == 'email'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#comment-email'));
                    $('#comment-email').get(0).setCustomValidity('invalid');
                } else if(key == 'name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#comment-name'));
                    $('#comment-name').get(0).setCustomValidity('invalid');
                } else if (key == 'message'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#comment-message'));
                    $('#comment-message').get(0).setCustomValidity('invalid');
                }
            });
            loading_submit_comment = false;
        }
    })
});

$('body').on('click', '#expand-comment', function(e) {
    e.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/comment/expandComment',
        data: {
            'profile_id': $('#profile-id').val()
        },
        success: function(data) {
            $('.list-comment').html(data);
            AddReadMore();
        }
    })
});

function AddReadMore() {
    var character_limit = 300;
    var read_more = " ... Read More";
    var read_less = " Read Less";

    $('body').find('.addReadMore').each(function() {
        var allstr = $(this).text();
        if (allstr.length > character_limit) {
            var first_str = allstr.substring(0, character_limit);
            var second_str = allstr.substring(character_limit, allstr.length);
            var str_add = first_str + "<span class='secondStr'>" + second_str + "</span>" +
                "<span class='readMore'>" + read_more + "</span>" +
                "<span class='readLess'>" + read_less + "</span>";
            $(this).html(str_add);
        }

    });
    $('.readMore, .readLess').off("click").on("click", function() {
        $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
    });
}
$(function() {
    AddReadMore();
});

var loading_submit_contact = false;
$('#submit-send-contact').on('click', function (e) {
    e.preventDefault();
    if (loading_submit_contact) return;
    loading_submit_contact = true;
    var formData = new FormData();
    var form = $(this).closest('form');
    formData.append('name', $('#contact-name').val());
    formData.append('email', $('#contact-email').val());
    formData.append('message', $('#contact-message').val());

    form.removeClass('was-validated');
    form.find('.invalid-feedback').remove();
    $('#contact-email').get(0).setCustomValidity('');
    $('#contact-name').get(0).setCustomValidity('');
    $('#contact-message').get(0).setCustomValidity('');
    $.ajax({
        type: "POST",
        url: '/kontakt/sendContact',
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
            form.html('<p class="success-message">' + data["message"] + '</p>')
            loading_submit_contact = false;
        },
        error: function (error) {
            form.addClass('was-validated');
            $.each(error.responseJSON.message, function (key,value) {
                if (key == 'email'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#contact-email'));
                    $('#contact-email').get(0).setCustomValidity('invalid');
                } else if(key == 'name'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#contact-name'));
                    $('#contact-name').get(0).setCustomValidity('invalid');
                } else if (key == 'message'){
                    $( "<div class='invalid-feedback'>" + value + "</div>" ).insertAfter($('#contact-message'));
                    $('#contact-message').get(0).setCustomValidity('invalid');
                }
            });
            loading_submit_contact = false;
        }
    })
});

$('.send-direct-message').on('click', function (e) {
    e.preventDefault();
    var send_message = $(this).closest('.send-message');
    var receiver_name = send_message.find('.user-receive-name').val();
    var receiver_id = send_message.find('.user-receive-id').val();
    $('#send-message-modal').modal('show');
    $('#send-message-modal').find('.receiver-name').html(receiver_name);
    $('#send-message-modal').find('.receiver-id').val(receiver_id);
});

var submit_send_message = false;
$('#submit-send-message').click(function(e) {
    e.preventDefault();
    submit_send_message = true;
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    var content = $('#content-direct-message').val();
    var receiverId = $('.receiver-id').val();
    if (receiverId == 0) return;
    if (content.trim() == '') {
        toastService.error('Error', 'Message is empty');
        return
    }
    var dataForm = {
        'content' : content,
        'receiverId' : receiverId
    };

    $.ajax({
        type:'POST',
        url:'/sendMessage',
        data: dataForm,
        success:function(data){
            $('#content-direct-message').val(null);
            toastService.success('Success', "Send message successfully");
            submit_send_message = false;
        },
        error: function(err) {
            console.log(err)
        }
    });
});
$('#submit-activation-email').on('click', function () {
    var form = $(this).closest('form');
    var _email = $('#email-activation').val();
    var show_error = $('#resend-activation-email-modal').find('.invalid-feedback');
        $.ajax({
            type: "POST",
            url: '/activationEmail',
            data: {
                email: _email
            },
            success: function (data) {
                console.log(data);
                toastService.success('success', data.message);
                $('#resend-activation-email-modal').modal('hide');
            },
            error: function (data) {
                show_error.show();
                form.addClass('was-validated');
                show_error.html(data.responseJSON.message);
            }
        })
})

$('#redirect-login').on('click',function () {
    $('#signupModal').modal('hide').on('hidden.bs.modal', function (e) {
        $('#signinModal').modal('show');
    });
})

$('.rotate-left').on('click', function (e) {
    e.preventDefault()
});
$('.rotate-right').on('click', function (e) {
    e.preventDefault()
});

function setRotateBtn(selector) {
    $('.rotate-left').on('click', function (e) {
        selector.croppie('rotate', 90);
    });

    $('.rotate-right').on('click', function (e) {
        selector.croppie('rotate', -90);
    });
};

function firstUpperCase(input)
{
    return input[0].toUpperCase()+input.substr(1).toLowerCase();
}
$('#close-banner-discount').on('click', function () {
    // $('.banner-discount').animate({height: "0", marginBottom: "-40px"}, 1000);
    $('.banner-discount').fadeOut(1000);
});






// WEBPACK FOOTER //
// ./resources/assets/js/app.js